import React, { useRef, useEffect, useState, useMemo } from "react";
import "../../../../i18n/i18n";
import { useTranslation } from "react-i18next";
import Button from "../../../../component/button/Button";
import Label from "../../../../component/label/Label";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Formik, Form, Field, ErrorMessage, useFormikContext, FieldArray  } from "formik";
import {
  useLocation,
  useNavigate, useParams
} from "react-router-dom";
import { Modal, Tooltip } from "react-bootstrap";
import Loader from "../../../../component/loader/Loader";
import Image from "../../../../component/image/Image";
import DateIcon from "../../../../assets/images/date-icon.svg";
import DeleteIcon from "../../../../assets/images/delete-icon.svg";
import JobIcon from "../../../../assets/images/jobIcon.png";
import "../../../../styles/careers/careers.scss";
import JobPreView from "./JobPreView";
import ResumeIcon from "../../../../assets/images/Resume.png";
import CloseIcon from "../../../../assets/images/close_icon.png";
import TextError from "../../../../component/formikComponent/TextError";
import * as Yup from "yup";
import HTMLLabel from "../../../../component/label/HTMLLabel";
import { jopApplicationError, defaultFieldError } from "../../../../config/labels/errorLabel";
import {
  FileSize,
  characters,
  format,
  linkedinProfileUrl,
  pinFormat,
  supportFormat,
  customEmail,
  defaultFileSize,
  allowedFilesForOptionThree,
  generalPhoneNumber,
  noMarkupOrLinks,
  htmlTagPattern,
} from "../../../../config/regex/regexPattern";
import { fileSignatureMatches } from "../../../../utils/fileSignature";
import JobView from "../jobView/JobView";
import {
  careersContryList,
  careersStateList,
  getJobDetails,
  getQuestionList,
  removeMicroSubmitJob,
  removSubmiutJob,
  submitJob,
  submitMicroSiteJob,
} from "../../../../redux/slices/careersSlices.reducer";
import { publishingDate } from "../CareersFucConfig";
import LinkedInIconJob from "../../../../assets/images/LinkedIn-Icon-job.png";
import QuestionsOpenIcon from "../../../../assets/images/questions-open.png";
import QuestionsCloseIcon from "../../../../assets/images/questions-close.png";
import SingleSelect from "../../../../component/singleSelect/SingleSelect";
import Model from "../../../../component/modal/Modal";
import LetterIcon from "../../../../assets/images/Letter.png";
import { apiPost } from "../../../../service/apiService";
import { endPoint } from "../../../../config/endPoint";
import { validateImgUrl, verifyImageUrl } from "../../../../config/globalEvent";
import { clientIds } from "../../../../config/clients/clients";
import ArrowLeft from "../../../../assets/images/clients/arrow-left.svg";
import zealLogo from "../../../../assets/images/clients/zeal-logo.png";

import closeFile from "../../../../assets/images/close-icon.svg";
import docIcon from "../../../../assets/images/doc-icon.svg";
import plusIcon from "../../../../assets/images/plus-icon.svg";
import plusBoxIcon from "../../../../assets/images/plus-box.svg";
import useClientConfig from "../../../../config/careers/clientConfig";
import { careersMessages } from "../../../../config/careers/careers";

interface ExtraQuestionSectionItems {
  section_id: string;
  section_status: boolean;
}

const timeLineInData = [
  {
    index: 0,
    label: "Details",
    currentPage: true,
    currentPageStyle: "current-page",
    completedPage: false,
    prsMoveColor: "",
    prsActive: false,
    prsMoveColorBorder: "",
    prsComColorBorder: "",
    journeyLine: false
  },
  {
    index: 1,
    label: "Documentation",
    currentPage: false,
    currentPageStyle: "",
    completedPage: false,
    prsMoveColor: "",
    prsActive: false,
    prsMoveColorBorder: "",
    prsComColorBorder: "",
    journeyLine: false
  },
  {
    index: 2,
    label: "Questions",
    currentPage: false,
    currentPageStyle: "",
    completedPage: false,
    prsMoveColor: "",
    prsActive: false,
    prsMoveColorBorder: "",
    prsComColorBorder: "",
    journeyLine: false
  },
];



const MicroJobApplay = (props: any) => {
  const { jobFilterData } = props;

  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const clientId = useParams();
  const jobDetails = useSelector((state: any) => state.careers.jobDetails);
  const submitJobRess = useSelector((state: any) => state.careers.submitMicroSiteJob);
  const countryList = useSelector((state: any) => state.careers.countryList);
  const stateList = useSelector((state: any) => state.careers.stateList);
  const {clientSiteSettings} = useClientConfig();
  const [extraQuestionSections, setExtraQuestionSections] = useState<any>([]);  
  const [invalidQuestionSections, setInvalidQuestionSections] = useState<any>([]);
  const [hideQuestionSection, setHideQuestionSection] = useState(false);  
  const formRef = useRef<any>([]);
  const questionId = useSelector((stete: any) => {
    return stete?.careers?.getQuestionId;
  });
  const clientConfig = useSelector((state: any) => state.careers.cliendConfig);
  const languageSettings = clientConfig?.data?.data?.clientSettings?.languageSettings;
  const email = clientConfig?.data?.data?.clientSettings?.hrEmail || clientConfig?.data?.data?.clientSettings?.email;

  const jobApplyLangLabels = languageSettings?.jobApply?.[0];
  const jobFormSettings = useMemo(() => {
    if(jobDetails){
      return jobDetails?.data?.data?.job?.jobApplyPageSettings;
    }

    return null;

  }, [jobDetails]);
  const FormCustomLabels = jobFormSettings?.label;

  const TitleLabel = FormCustomLabels?.title ? FormCustomLabels?.title : jobApplyLangLabels?.title;
  const FirstNameLabel = FormCustomLabels?.firstName ? FormCustomLabels?.firstName : jobApplyLangLabels?.firstName;
  const LastNameLabel = FormCustomLabels?.lastName ? FormCustomLabels?.lastName : jobApplyLangLabels?.lastName;
  const PreferredNameLabel = FormCustomLabels?.preferredName ? FormCustomLabels?.preferredName : jobApplyLangLabels?.preferredName;
  const MobileLabel = FormCustomLabels?.mobile ? FormCustomLabels?.mobile : jobApplyLangLabels?.mobile;
  const EmailLabel = FormCustomLabels?.email ? FormCustomLabels?.email : jobApplyLangLabels?.email;
  const LinkedinProfileLabel = FormCustomLabels?.linkedinProfile ? FormCustomLabels?.linkedinProfile : jobApplyLangLabels?.linkedinProfile;
  const Address1Label = FormCustomLabels?.address1 ? FormCustomLabels?.address1 : jobApplyLangLabels?.address1;
  const Address2Label = FormCustomLabels?.address2 ? FormCustomLabels?.address2 : jobApplyLangLabels?.address2;
  const CityLabel = FormCustomLabels?.city ? FormCustomLabels?.city : jobApplyLangLabels?.suburbCity;
  const CountryLabel = FormCustomLabels?.country ? FormCustomLabels?.country : jobApplyLangLabels?.country;
  const StateLabel = FormCustomLabels?.state ? FormCustomLabels?.state : jobApplyLangLabels?.state;
  const PostCodeLabel = FormCustomLabels?.postCode ? FormCustomLabels?.postCode : jobApplyLangLabels?.postcode;
  const ResumeLabel = FormCustomLabels?.resume ? FormCustomLabels?.resume : jobApplyLangLabels?.resume;
  const CoverLetterLabel = FormCustomLabels?.coverLetter ? FormCustomLabels?.coverLetter : jobApplyLangLabels?.coverLetter;
  const AdditionalDocumentationLabel = FormCustomLabels?.additionalDocumentation ? FormCustomLabels?.additionalDocumentation : jobApplyLangLabels?.additionalDocumentation;
  
  const file_size_from_api = (jobFormSettings?.fileSize !== 0 || jobFormSettings?.fileSize !== null) ? jobFormSettings?.fileSize : defaultFileSize;
    const FILE_SIZE = () => {
      return (file_size_from_api*1024*1024);
    };
  
    const getFileTypes = (userReadable = false) => {
      let fileTypes = jobFormSettings?.fileType !== null ? jobFormSettings?.fileType : [];
      if((fileTypes ?? []).length === 0) {
        fileTypes = allowedFilesForOptionThree; // Default File format if not set in API
      }
      let finalFileType: string[] = [];
      if((fileTypes ?? []).length > 0) {
        fileTypes.forEach((fileRow: any) => {
          if(userReadable){
            finalFileType.push(fileRow.fileType);
          }else{
            finalFileType.push(fileRow.fileVal);
          }        
        });
      }
  
      if(userReadable){
        return finalFileType.join(", ");
      }else{
        return finalFileType;
      }
    };
  
    const allowedFileFormats = getFileTypes();
    const fileSizeErrorMessage = t("fileSizError", {size: file_size_from_api });
  // const queryParams = new URLSearchParams(location.search);
  // console.log(queryParams);
  const [jobApplyForm, setJobApplyForm] = useState({
    title: "",
    firstName: "",
    lastName: "",
    preferredName: "",
    phone: "",
    emailAddress: "",
    address_1: "",
    address_2: "",
    suburb_city: "",
    state: "",
    post_code: "",
    country: "",
    interestprimarycategory: "",
    interestsubcategories: "",
    resume: null,
    coverLetter: null,
    linkedinProfile: "",
    addDoc: null,
    tAndC: false,
    categoryList: []
  });
  const [jobPreViewSection, setJobPreViewSection] = useState(false);
  const observedDiv: any = useRef(null);
  const submitButtonRef: any = useRef(null);
  const dynamikFormDataRef: any = useRef(null);
  const sideBarWidth: any = useRef(null);
  const footerheight: any = useRef(null);
  const contactDetails: any = useRef(null);
  const jobDataDiv: any = useRef(null);
  const documentationDiv: any = useRef(null);
  const overAllSection: any = useRef(null);
  const residentialAddress: any = useRef(null);
  const [isCustomFormInvalid, setCustomFormValidity]: any = useState<boolean>(true);
  const [customFormRequiredFields, setCustomFormRequiredFields] = useState<any>([]);
  const [customFormRequiredReference, setCustomFormRequiredReference] = useState<any>([]);
  const [questionOpenAndClose, setQuestionOpenAndClose] = useState(true);
  const [country, setCountry] = useState<any>([]);
  const [states, setStates] = useState<any>([]);
  const [jobModel, setJobModel] = useState(false);
  const [viewJobControl, setViewJobControl] = useState<boolean>(true);
  const [careersTotalBody, setCareersTotalBody] = useState(0);
  const [timeListData, setTimeLineData] = useState(timeLineInData);
  const [profileQuestion, setProfileQuestion] = useState<any>({});
  const [selectedCategoryDropdown, setSelectedCategoryDropdown] = useState<any>([{}]);
  const [currentSelectedCategoryPair, setCurrentSelectedCategoryPair] = useState<any>({});
  const [currentSubCategory, setCurrentSubcategory] = useState({selected:""});
  const [addedCategoryReferenceList, setCategoryReferenceList] = useState<any>([]);
  const [serverFormKeys, setServerFormKeys] = useState<string[]>([]);
  const [showLink, setShowLink] = useState(false);
  const [subHeaderStyle, setSubHeaderStyle] = useState("");
  const [jobBodyStyle, setJobBodyStyle] = useState("job-body");
  const [showSearchFilter, setShowSearchFilter] = useState(false);
  const [qaShowHide, setQaShowHide] = useState<string>("  ");
  const FormDataDiv: any = useRef(null);
  const routeParams = useParams();
  const [showDocumentations, setShowDocumentations] = useState(false);
  const [resumeDragActive, setResumeDragActive] = useState(false);
  const [coverLetterDragActive, setCoverLetterDragActive] = useState(false);
  const [addDocDragActive, setAddDocDragActive] = useState(false);
  const templateName = clientSiteSettings?.templateName;
  const [extraSectionShowHide, setExtraSectionShowHide] = useState<ExtraQuestionSectionItems[]>([]);


  const redirectListing = () => {
    navigate("/");
  };

  useEffect(() => {
    if(clientId?.from !== "direct"){
      setShowLink(!false);
      // setSubHeaderStyle("subheader-3-new");
      // setJobBodyStyle("job-body-new");
    }
  }, [location.pathname]);

  useEffect(() => {
    if(templateName === "template_4" && clientId?.from !== "direct"){
      setShowSearchFilter(!false);
      setJobBodyStyle("job-body-search-new");
    }
  }, [location.pathname, clientConfig]);

  useEffect(() => {
    if(clientConfig?.data?.data?.clientSettings?.isMicroSite !== 1){
        dispatch<any>(getQuestionList());
        dispatch<any>(getJobDetails(clientId?.id));
     }
  }, [location.pathname, clientId?.id]);


  const extraQuestionList : any = [];
    const invalidQuestionsList : any = [];
    const sectionKeyList : any = [];
    useEffect(() => {
      const additionalSection = jobDetails?.data?.data?.job?.additionalSection;
      const questionSection = jobDetails?.data?.data?.job?.questions;
     
      if(additionalSection && Object.keys(additionalSection)?.length > 0){
        Object.keys(additionalSection).forEach((key,index) => {
          const questionsField = questionSection?.filter((ress: any) => ress.section === key);
          extraQuestionList.push({
            ...additionalSection?.[key],
            "questionsField": questionsField,
            "section_key": key
          });
  
          sectionKeyList.push(key);
  
         
  
          // setExtraSectionShowHide((prev: any) => [...prev, {section_id: key, section_status: true}]);
          const existingSection = extraSectionShowHide?.find((section: any) => section.section_id === key);
          if (existingSection) {
            existingSection.section_status = true;
          } else {
            setExtraSectionShowHide((prev: any) => [...prev, { section_id: key, section_status: true }]);
          }
        });
  
  
        //Invalid section key list      
        const questionsField = questionSection?.filter((ress: any) => !sectionKeyList.includes(ress.section) && ress.section !== null);
        if(questionsField.length > 0){
          invalidQuestionsList.push(questionsField);
        }
  
      }
      extraQuestionList.sort((a:any, b:any) => a.sequence - b.sequence);
      setExtraQuestionSections(extraQuestionList);
      setInvalidQuestionSections(invalidQuestionsList);
  
      
  
      const emptyQuestionsField = questionSection?.filter((ress: any) => ress.section === null);
      if((emptyQuestionsField?.length === 0 && jobDetails?.data?.data?.job?.questions?.length !== emptyQuestionsField?.length)){
        setHideQuestionSection(true);
      }
  
     
    }, [jobDetails]);
  const getExtraSectionStatus = (section_id: string) => {
    const sectionStatus = extraSectionShowHide.find((ress: any) => ress.section_id === section_id);
    return sectionStatus?.section_status;
  };

  const setTitleShowOrHide = () => {
    setQuestionOpenAndClose(!questionOpenAndClose);
  };

  const updateExtraSectionStatus = (section_id: string, status: boolean) => {
    const updatedSection = extraSectionShowHide.map((ress: any) => {
      if (ress.section_id === section_id) {
        return {
          ...ress,
          section_status: status,
        };
      } else {
        return ress;
      }
    });
    setExtraSectionShowHide(updatedSection);
  };

  const setExtraTitleShowOrHide = (section_id: string) => {
    let previousSectionStatus = getExtraSectionStatus(section_id);
    const updatedSection = extraSectionShowHide.map((ress: any) => {
      if (ress.section_id === section_id) {
        return {
          ...ress,
          section_status: !previousSectionStatus,
        };
      } else {
        return ress;
      }
    });
    setExtraSectionShowHide(updatedSection);

  };

  useEffect(() => {
    dispatch<any>(careersContryList());
    if(clientConfig?.data?.data?.clientSettings?.isMicroSite !== 1){
      window.scrollTo(0, 0);
    }
  }, []);

  useEffect(() => {
    if (stateList?.status === 200) {
      const stateListData = stateList?.data?.data?.map((ress: any) => {
        return {
          ...ress,
          label: ress?.name,
          value: ress?.code,
        };
      });
      setStates(stateListData);
    }
  }, [stateList]);
  useEffect(() => {
    if (countryList?.status === 200) {
      const countryListData = countryList?.data?.data?.map((ress: any) => {
        return {
          ...ress,
          label: ress.name,
          value: ress.countryId,
        };
      });
      setCountry(countryListData);
    }
  }, [countryList]);

  useEffect(() => {
    if (jobDetails?.status === 200) {
      const jobQuestions = { ...jobDetails?.data?.data?.job };
      
      if (jobQuestions?.generalJobApp === 1) {
        setViewJobControl(false);
      } 
      else {
        setViewJobControl(!false);
      }

      jobQuestions?.questions?.forEach((element: any) => {
        if (element?.required === 1) {
          setServerFormKeys((prs) => [...prs, element.extId]);
          if(customFormRequiredFields.length <= 0) {
            setCustomFormRequiredFields((fields:any) => [...fields, element.extId.toString()]);
            setCustomFormRequiredReference((fields:any) => [...fields, 
              {
                fieldId : element.extId.toString(),
                label : element.text
              }
            ]);
          }
        }

        if (element.type === "multiple") {
          setJobApplyForm((prs) => {
            return {
              ...prs,
              [element.extId]: [],
            };
          });
        } else {
          setJobApplyForm((prs) => {
            return {
              ...prs,
              [element.extId]: "",
            };
          });
        }
      });

      const profileQuestion: any = { ...jobDetails?.data?.data?.job?.profile };

      if (
        jobQuestions?.questions?.length === undefined &&
        Object.keys(profileQuestion)?.length === 0
      ) {
        const updatedtimeListData = timeListData.filter((timeList) => { 
          return timeList.index !== 2; 
        });
        setTimeLineData(updatedtimeListData);
      }
      if (Object.keys(profileQuestion)?.length) {
        const newProfileQuestion = [];
        const obj: any = {};

        Object.keys(profileQuestion)?.forEach((ress) => {
          const subKey = Object.keys(profileQuestion[ress]);
          const subKeyArray: any = [];
          if (profileQuestion[ress]?.attributes?.type === "multiselect") {
            setJobApplyForm((prs) => {
              return {
                ...prs,
                [ress]: [],
              };
            });
          } else if (
            profileQuestion[ress]?.attributes?.type === "singleselect"
          ) {
            setJobApplyForm((prs) => {
              return {
                ...prs,
                [ress]: "",
              };
            });
          }

          if (profileQuestion[ress]?.attributes?.required) {
            setServerFormKeys((prs) => [...prs, ress]);
            if(customFormRequiredFields.length <= 0) {
              setCustomFormRequiredFields((fields:any) => [...fields, ress]);
            }
          }

          // console.log(profileQuestion[ress][subKey[2]]);
          profileQuestion[ress][subKey[2]].forEach((data: any) => {
            // console.log(data);
            let subkeyArrData = {
              label: data.value,
              value: data.attributes.id,
              id: data.attributes.id + "_" + ress?.toString(),
              depdropdown: data.subcategories || null
            };
            subKeyArray.push(subkeyArrData);
          });
          obj[ress] = {
            attributes: profileQuestion[ress]["attributes"],
            option: subKeyArray,
            label: profileQuestion[ress]["label"],
            fieldId: ress,
          };
        });
        //Adding profile questions to error summary
        Object.keys(obj)?.forEach((ress:any) => {
          if(obj[ress]?.attributes?.required) {
            setCustomFormRequiredReference((fields:any) => [...fields, 
              {
                fieldId : obj[ress]?.fieldId,
                label : obj[ress]?.label
              }
            ]);
          }
        });
        setProfileQuestion(obj);        
      }
    }
  }, [jobDetails]);
  useEffect(() => {
    if (submitJobRess.status === 200) {
      if (submitJobRess?.data?.statusCode === 200) {
        toast(submitJobRess?.data?.data?.result, {
          type: "success",
          autoClose: 5000,
        });
        dispatch<any>(removeMicroSubmitJob());
        setTimeout(() => {
          navigate("/");
        }, 5000);
      } else if (submitJobRess?.data?.statusCode === 400) {
        toast(submitJobRess?.data?.data?.error?.error, {
          type: "error",
          autoClose: 60000,
        });
        dispatch<any>(removeMicroSubmitJob());
      }
    } else if (submitJobRess.status === 400 || submitJobRess.status === 429) {
      // Validation and rate-limit rejections carry data.errors plus a message the applicant can act on.
      const serverMessage = submitJobRess?.data?.data?.errors ? submitJobRess?.data?.message : "";
      const errorMessage = serverMessage || careersMessages.apiErrorMessage?.replace("{{EMAIL}}", email);
      toast(errorMessage, {
        type: "error",
        autoClose: 60000,
      });
      dispatch<any>(removeMicroSubmitJob());
    }
  }, [submitJobRess]);

  const jobPreView = () => {
    // console.log(overAllSection?.current?.offsetHeight);
    // setTimeout((/) => {
    setJobPreViewSection(!jobPreViewSection);

    setTimeout(() => {
      const offsetHeight =
        document.getElementById("careers-body")?.offsetHeight;
      if (offsetHeight) {
        setCareersTotalBody(offsetHeight);
      }
      window.scroll(0, 0);
    }, 500);

    // }, 500);/
  };
  const checkWithFile = (value: any) => {
    // return true;
    if (value !== null) {
      return value !== null &&
        value instanceof File &&
        value["size"] <= FILE_SIZE()
        ? true
        : false;
    } else {
      return true;
    }
  };

  const checkIsAddDocFileSelected = (value: any) => {

    if(value === null && jobFormSettings?.isAdditionalDocRequired === 1){
      return false;
    }else{
      return true;
    }

  };

  const checkIsCoverFileSelected = (value: any) => {

    if(value === null && jobFormSettings?.isCoverLetterMandatory === 1){
      return false;
    }else{
      return true;
    }

  };


  const checkIsResumeFileSelected = (value: any) => {

    if(value === null && jobFormSettings?.isResumeMandatory === 1){
      return false;
    }else{
      return true;
    }

  };

  const checkWithFileFormat = (value: any) => {
    if (value !== null) {
      return value !== null &&
        value instanceof File &&
        supportFormat.includes(value.type)
        ? true
        : false;
    } else {
      return true;
    }
  };
  const getFileExt = (params: any) => {
    if (params instanceof File) {
      // const aaaWithoutExtension:any = params?.name?.toString()?.lastIndexOf(".");
      // console.log(aaaWithoutExtension);
      const parts = params?.name?.split(".");
      const fileExtension = parts[parts.length - 1];
      return fileExtension;

      // return params.name.split(".")[1];
    } else {
      return "";
    }
  };
  const validateSchema = () =>
      Yup.object().shape({
        title: Yup.string()
          .when("isRequired", {
            is: (showEmail: boolean) => jobFormSettings?.isTitleMandatory === 1 ? true : false, 
            then: (schema: Yup.StringSchema) => schema.required(t(jopApplicationError.title_required)),
            otherwise: (schema: Yup.StringSchema) => schema
          }),
        firstName: Yup.string()
          .when("isRequired", {
            is: (showEmail: boolean) => jobFormSettings?.isFirstNameMandatory === 1 ? true : false, 
            then: (schema: Yup.StringSchema) => schema.required(t(jopApplicationError.first_name_required)).matches(characters, t(jopApplicationError.first_name_invalid)),
            otherwise: (schema: Yup.StringSchema) => schema.matches(characters, t(jopApplicationError.first_name_invalid))
          }),
  
        lastName: Yup.string()
          .when("isRequired", {
            is: (showEmail: boolean) => jobFormSettings?.isLastNameMandatory === 1 ? true : false,
            then: (schema: Yup.StringSchema) => schema.required(t(jopApplicationError.last_name_required)).matches(characters, t(jopApplicationError.last_name_invalid)),
            otherwise: (schema: Yup.StringSchema) => schema.matches(characters, t(jopApplicationError.last_name_invalid))
          }),
        preferredName: Yup.string()
        .when("isRequired", {
          is: (showEmail: boolean) => jobFormSettings?.isPreferredNameMandatory === 1 ? true : false,
          then: (schema: Yup.StringSchema) => schema.required(t(jopApplicationError.preferred_name_required)).matches(characters, t(jopApplicationError.preferred_name_invalid)),
          otherwise: (schema: Yup.StringSchema) => schema.matches(characters, t(jopApplicationError.preferred_name_invalid))
        }),
  
        phone: Yup.string()
        .when("isRequired", {
          is: (showEmail: boolean) => jobFormSettings?.isMobileMandatory === 1 ? true : false,
          then: (schema: Yup.StringSchema) => schema.required(t(jopApplicationError.mobile_required)).matches(generalPhoneNumber, t(jopApplicationError.mobile_invalid)),
          otherwise: (schema: Yup.StringSchema) => schema.matches(generalPhoneNumber, t(jopApplicationError.mobile_invalid))
        }),  
        
        emailAddress: Yup.string()
        .when("isRequired", {
          is: (showEmail: boolean) => jobFormSettings?.isEmailMandatory === 1 ? true : false,
          then: (schema: Yup.StringSchema) => schema.required(t(jopApplicationError.email_required)).matches(customEmail, t(jopApplicationError.email_invalid)),
          otherwise: (schema: Yup.StringSchema) =>  schema.matches(customEmail, t(jopApplicationError.email_invalid))
        }), 
  
        linkedinProfile: Yup.string()
        .when("isRequired", {
          is: (showEmail: boolean) => jobFormSettings?.isLinkedinMandatory === 1 ? true : false,
          then: (schema: Yup.StringSchema) => schema.required(t(jopApplicationError.linkedin_profile_required)).matches(linkedinProfileUrl, t(jopApplicationError.linkedin_profile_invalid)),
          otherwise: (schema: Yup.StringSchema) => schema.matches(linkedinProfileUrl, t(jopApplicationError.linkedin_profile_invalid))
        }),
  
        address_1: Yup.string()
        .matches(noMarkupOrLinks, { message: t("Links and HTML aren't allowed in this field"), excludeEmptyString: true })
        .when("isRequired", {
          is: (showEmail: boolean) => jobFormSettings?.isAddress1Mandatory === 1 ? true : false,
          then: (schema: Yup.StringSchema) => schema.required(t(jopApplicationError.address_1_required)),
          otherwise: (schema: Yup.StringSchema) => schema
        }),
  
        address_2: Yup.string()
        .matches(noMarkupOrLinks, { message: t("Links and HTML aren't allowed in this field"), excludeEmptyString: true })
        .when("isRequired", {
          is: (showEmail: boolean) => jobFormSettings?.isAddress2Mandatory === 1 ? true : false,
          then: (schema: Yup.StringSchema) => schema.required(t(jopApplicationError.address_2_required)),
          otherwise: (schema: Yup.StringSchema) => schema
        }),
  
        suburb_city: Yup.string()
        .matches(noMarkupOrLinks, { message: t("Links and HTML aren't allowed in this field"), excludeEmptyString: true })
        .when("isRequired", {
          is: (showEmail: boolean) => jobFormSettings?.isCityMandatory === 1 ? true : false,
          then: (schema: Yup.StringSchema) => schema.required(t(jopApplicationError.suburb_city_required)),
          otherwise: (schema: Yup.StringSchema) => schema
        }),
  
        state: Yup.string()
        .when("isRequired", {
          is: (showEmail: boolean) => jobFormSettings?.isStateMandatory === 1 ? true : false,
          then: (schema: Yup.StringSchema) => schema.required(t(jopApplicationError.state_required)),
          otherwise: (schema: Yup.StringSchema) => schema
        }),
  
        post_code: Yup.string()
        .when("isRequired", {
          is: (showEmail: boolean) => jobFormSettings?.isPostCodeMandatory === 1 ? true : false,
          then: (schema: Yup.StringSchema) => schema.required(t(jopApplicationError.post_code_required)).matches(pinFormat, jopApplicationError.post_code_invalid),
          otherwise: (schema: Yup.StringSchema) => schema.matches(pinFormat, jopApplicationError.post_code_invalid)
        }),
  
        country: Yup.string()
        .when("isRequired", {
          is: (showEmail: boolean) => jobFormSettings?.isCountryMandatory === 1 ? true : false,
          then: (schema: Yup.StringSchema) => schema.required(t(jopApplicationError.country_required)),
          otherwise: (schema: Yup.StringSchema) => schema
        }),
  
        resume: Yup.mixed()
          .nullable()
          .test("is-required", t(jopApplicationError.resume_required), (value) => {
            return checkIsResumeFileSelected(value);
          }).test(
            "fileFormat",
            t(jopApplicationError.file_invalid),
            // (value: any) => value !== null && supportFormat.includes(value.type)
            (value: any) => {
              if(getFileExt(value) === "mdi"){
                return supportFormat.includes(getFileExt(value));
              } else {
                return checkWithFileFormat(value);
              }
            }
          ).test(
            "fileSize",
            t(fileSizeErrorMessage),
            (value: any) => {
              return checkWithFile(value);
            }
          ).test(
            "fileContent",
            t(jopApplicationError.file_invalid),
            (value: any) => (value instanceof File ? fileSignatureMatches(value) : true)
          ),
        coverLetter: Yup.mixed()
          .nullable()
          .test("is-required", t(jopApplicationError.cover_letter_required), (value) => {
            return checkIsCoverFileSelected(value);
          })        
          .test("fileFormat", t(jopApplicationError.file_invalid), (value: any) => {
            if(getFileExt(value) === "mdi"){
              return supportFormat.includes(getFileExt(value));
            } else {
              return checkWithFileFormat(value);
            }
          }).test(
            "fileSize",
            fileSizeErrorMessage,
            (value: any) => { 
              return checkWithFile(value);
            }
          ).test(
            "fileContent",
            t(jopApplicationError.file_invalid),
            (value: any) => (value instanceof File ? fileSignatureMatches(value) : true)
          ),
       
        addDoc: Yup.mixed()
          .nullable()
          .test("is-required", t(jopApplicationError.aAdditional_documentation_required), (value) => {
              return checkIsAddDocFileSelected(value);
          })        
          .test("fileFormat", t(jopApplicationError.file_invalid), (value: any) => {
            if(getFileExt(value) === "mdi"){
              return supportFormat.includes(getFileExt(value));
            } else {
              return checkWithFileFormat(value);
            }
          }).test(
            "fileSize",
            fileSizeErrorMessage,
            (value: any) => {
              return checkWithFile(value);
            }
          ).test(
            "fileContent",
            t(jopApplicationError.file_invalid),
            (value: any) => (value instanceof File ? fileSignatureMatches(value) : true)
          ),
        categoryList: Yup.array()
          .test("categoryList", t("Please select atleast one interest"), (value:any) => {
            if(Object.keys(profileQuestion).length > 0 && "categories" in profileQuestion) {
              if(value.length >= 1) {
                return true;
              }
              else {
                return false;
              }
            }
            else {
              return true;
            }
          }),
          tAndC: Yup
          .boolean()
          .required("You must accept the terms and conditions")
          .oneOf([clientConfig?.data?.data?.clientSettings?.terms !== null], "You must accept the terms and conditions")
          
      });

  const getFileName = (params: any) => {
    if (params instanceof File) {
      return params.name;
    } else {
      return "";
    }
  };

  const getFileTobash64 = (params: any) => {
    if (params instanceof File) {
      return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.readAsDataURL(params);
        fileReader.onload = () => {
          resolve(fileReader.result);
        };
        fileReader.onerror = (error) => {
          reject(error);
        };
      });
    } else {
      return null;
    }
  };

  const formatDependentCategories = (apiData:any) => {
    let formattedData = {...apiData};
    let formattedOptions:any = [];
    formattedData.option?.forEach((apiDataNode:any) => {   
      let apiDataRef:any;   
      //tests for existing parent category present without any subcats selected, to skip the sub cat processing
      if(addedCategoryReferenceList.filter((e:any)=> {
        return apiDataNode.value === e.categoryId && e.subCategoryId === null;
      }).length === 0) {
        //no full parent category selection found, processing sub categories
        let processedSubCats:any = [];
        apiDataNode.depdropdown.subcategory.forEach((subcat:any) => {          
          if(addedCategoryReferenceList.filter((catPair:any) => catPair.subCategoryId === subcat.attributes.id).length > 0){
            processedSubCats.push(subcat);
          }
        });
        //shallow copy to edit the read-only looping iterator, inside the loop
        if(processedSubCats.length > 0) {
          apiDataRef = {...apiDataNode};
          apiDataRef.depdropdown = {          
            attributes : apiDataNode.depdropdown.attributes,
            label : apiDataNode.depdropdown.label,
            subcategory : processedSubCats
          };
          formattedOptions.push(apiDataRef);
        }
      }
      else {
        //full category found, dropping sub categories and pushing the full parent inside the submit data;
        formattedOptions.push(apiDataNode);
      }
    });
    formattedData.option = formattedOptions;
    return formattedData;
  };

  const formatSubmissionJson = (submissionData:any) => {
    let subData:any;
    let catData:any = [];  
    //process category array
    submissionData.option.forEach((opt:any) => {      
      catData.push({
        attributes: {
          id: opt.value
        },
        value : opt.label,
        subCategories : {
          subCategory : opt.depdropdown.subcategory
        }
      });
    });
    subData = {      
      attributes :{
        label : submissionData.label,
        type: submissionData.attributes.type,
        required: submissionData.attributes.required
      },
      category: catData
    };
    return subData;  
  };

  const submitApplayJob = async (params: any) => {    
    const userJobData = jobDetails?.data?.data?.job?.questions?.map(
      (ress: any) => {
        const questions = Object.keys(params).filter(
          (data: any) => data === ress.extId.toString()
        );
        if (params[questions[0]].length > 0) {
          if (Array.isArray(params[questions[0]])) {
            return {
              ...ress,
              answers: ress.answers.filter((data: any) =>
                params[questions[0]].some((rr: string) => rr === data.id)
              ),
            };
          } else {
            if (ress.type === "single") {
              return {
                ...ress,
                answers: ress.answers.filter(
                  (data: any) => data.id === params[questions[0]]
                ),
              };
            } else {
              return {
                ...ress,
                answers: [params[questions[0]]],
              };
            }
          }
        } else {
          return {
            ...ress,
            answers: [],
          };
        }
      }
    );
    // console.log(userJobData);

    // const candidateProfile = jobDetails?.data?.data?.job?.profile?.map((ress: any) => {
    //     console.log(jobDetails?.data?.data?.job?.profile);

    //     return ress;
    // });
    // console.log(jobDetails);
    const candidateProfile: any = {};
    if (jobDetails?.data?.data?.job?.profile !== null) {
      const profileDataUpdata = Object.keys(
        jobDetails?.data?.data?.job?.profile
      );
      
      const profile = { ...jobDetails?.data?.data?.job?.profile };
      const userUpdateParams = Object.keys(params);

      for (let i = 0; i < profileDataUpdata.length; i++) {
        const element = profileDataUpdata[i];

        const subKey1: any = {};
        const subKeys = Object.keys(profile[element]);
        for (let k = 0; k < subKeys.length; k++) {
          const elementSub = subKeys[k];
          if (Array.isArray(profile[element][elementSub])) {
            const lastValue: any[] = [];
            let arrParam = params[element];
            const aa = profile[element][elementSub].map((ress: any) => {               
              if (ress.attributes?.id === params[element]) {
                subKey1[elementSub] = ress;
              } else {
                for (let h = 0; h < arrParam.length; h++) {
                  //Fix added for the initial bug that occured due to expecting all params[element] to be an array, it started iterating over string, this normalizes all incoming as array
                  if(typeof params[element] === "string") {
                    arrParam = [params[element]];
                  }
                  const element5 = arrParam[h];
                  if (ress.attributes?.id === element5?.split("_")[0]) {                    
                    lastValue.push(ress);
                  }
                }
                subKey1[elementSub] = lastValue;
              }

              return ress;
            });
          } else {
            subKey1[elementSub] = profile[element][elementSub];
          }
        }
        candidateProfile[element] = subKey1;
      }
    }
    //interject for adding dependent dropdown data to submission process
    if(Object.keys(profileQuestion)?.length > 0) {
      let preformattedCategories = formatDependentCategories(profileQuestion.categories);
      candidateProfile["categories"] = formatSubmissionJson(preformattedCategories);
    }

    const filterCountryCode = countryList?.data?.data?.filter(
      (ress: any) => ress.countryId.toString() === params.country
    );


    const obj: any = {};
    obj["CandidateProfile"] = Object.keys(candidateProfile)?.length > 0 ? candidateProfile : [];
    obj["title"] = params.title;
    obj["firstName"] = params.firstName;
    obj["lastName"] = params.lastName;
    obj["preferredName"] = params.preferredName;
    obj["email"] = params.emailAddress;
    obj["contactPhone"] = params.phone;
    obj["resumeDocName"] = await getFileName(params.resume);
    obj["resumeDocExt"] = await getFileExt(params.resume);
    obj["resumeBase64"] = await getFileTobash64(params.resume);
    obj["linkedInProfile"] = params.linkedinProfile;

    obj["coverDocName"] = await getFileName(params.coverLetter);
    obj["coverDocExt"] = await getFileExt(params.coverLetter);
    obj["coverBase64"] = await getFileTobash64(params.coverLetter);
    obj["otherDocName"] = await getFileName(params.addDoc);
    obj["otherDocExt"] = await getFileExt(params.addDoc);
    obj["otherBase64"] = await getFileTobash64(params.addDoc);
    obj["infoBlock"] = "";
    obj["address1"] = params.address_1;
    obj["address2"] = params.address_2;
    obj["city"] = params.suburb_city;
    obj["state"] = params.state;
    obj["postCode"] = params.post_code;
    // obj["country"] = params.country;
    obj["country"] = filterCountryCode?.[0]?.name || null;
    obj["source"] = clientId?.from;
    obj["extId"] = jobDetails?.data?.data?.job?.extId;
    obj["screeningAnswers"] = userJobData?.some(
      (ress: any) => ress.answers?.length > 0
    )
      ? userJobData
      : [];
    dispatch<any>(submitMicroSiteJob(obj));
  };
  const titleList = [
    {
      label: "Mr",
      value: "Mr",
    },
    {
      label: "Mrs",
      value: "Mrs",
    },
    {
      label: "Miss",
      value: "Miss",
    },
  ];
  const getStatusList = (params: string) => {
    dispatch<any>(careersStateList(params));
  };
  const jobViewodelClose = () => {
    setJobModel(false);
  };
  const JobViewModelHeader = () => {
    return (
      <>
        {clientConfig?.data?.data?.clientSettings?.isMicroSite !== 1 ? (
          <Modal.Header>
            {/* <Modal.Title> */}
            <p className="mb-0 job-view-model d-flex w-100">
              <div className="preview-header">Preview Job Ad</div>
              {/* <div> */}
              <div className="preview-close-icon ms-auto">
                {/* onClick={() => saveModelClose()} */}
                <i
                  role="button"
                  className="pi pi-times"
                  onClick={() => jobViewodelClose()}
                ></i>
              </div>
              {/* </div> */}
            </p>
            {/* </Modal.Title> */}
          </Modal.Header>
        ) : null}
      </>
    );
};
  const JobViewModel = () => {
    return (
      <>
        <Modal.Body className="p-0">
          <div className="d-flex  justify-content-between">
            <div>
              <div>
                <JobPreView />
                {/* <JobView /> */}
              </div>
            </div>
          </div>
        </Modal.Body>
      </>
    );
  };

  const updateTimeLine:any = (timeListData: any, index: number) => {
    const formErrorKeys:any = formRef?.current?.errors;
    return timeListData.map((ress: any) => {
      if (index === 1) {        
        //TIMELINE 2 file upload
        if (ress.index === 0) {
          if (
            !formRef.current.dirty ||
            formErrorKeys["title"] ||
            formErrorKeys["firstName"] ||
            formErrorKeys["lastName"] ||
            formErrorKeys["country"] ||
            formErrorKeys["phone"] ||
            formErrorKeys["emailAddress"] ||
            formErrorKeys["state"]
          ) {
            return {
              ...ress,
              currentPage: false,
              currentPageStyle: "current-page",
              completedPage: false,
              prsActive: true,
              prsMoveColor: "",
              prsComColorBorder: "#3A3E54",
              journeyLine:true
            };
          } else {
            return {
              ...ress,
              currentPage: false,
              currentPageStyle: "",
              completedPage: true,
              prsMoveColor: "job-timeline-border",
              prsMoveColorBorder: "job-timeline-border",
              prsActive: true,
              journeyLine:true
            };
          }
        } else if (ress.index === 1) {    
          if (
            !formRef.current.dirty ||
            formErrorKeys["resume"]
          ) {
            return {
              ...ress,
              currentPage: true,
              currentPageStyle: "current-page",
              completedPage: false,
              prsActive: true,
              prsMoveColor: "",
              journeyLine: (timeListData[2] && timeListData[2].completedPage) ? true : false
            };
          } else {
            return {
              ...ress,
              currentPage: true,
              currentPageStyle: "current-page",
              completedPage: true,
              prsMoveColor: "",
              prsMoveColorBorder: ress?.prsActive ? "" : "",
              prsActive: true,
              journeyLine: (timeListData[2] && timeListData[2].completedPage) ? true : false
            };
          }
        } else if (ress.index === 2) {          
          if(!formRef.current.dirty || isCustomFormInvalid) {
            return {
              ...ress,
              currentPage: false,
              currentPageStyle: "",
              completedPage: false,
              prsMoveColor: "",
              prsMoveColorBorder: ress?.prsActive ? "" : "",
              prsActive: true,
              journeyLine:false 
            };
          } 
          else {
            return {
              ...ress,
              currentPage: false,
              currentPageStyle: "",
              completedPage: true,
              prsMoveColor: "",
              prsMoveColorBorder: ress?.prsActive ? "" : "",
              prsActive: true,
              journeyLine:false
            };
          }
        } else {
          return ress;
        }
        // }
      } else if (index === 2) {
        //TIMELINE 3
        if (ress.index === 0) {
          if (
            !formRef.current.dirty ||
            formErrorKeys["title"] ||
            formErrorKeys["firstName"] ||
            formErrorKeys["lastName"] ||
            formErrorKeys["country"] ||
            formErrorKeys["phone"] ||
            formErrorKeys["emailAddress"] ||
            formErrorKeys["state"]
          ) {
            return {
              ...ress,
              currentPage: false,
              currentPageStyle: "current-page",
              completedPage: false,
              prsActive: true,
              prsMoveColor: "",
              prsComColorBorder: "#3A3E54",
              journeyLine:true
            };
          } else {
            return {
              ...ress,
              currentPage: false,
              currentPageStyle: "",
              completedPage: true,
              prsMoveColor: "job-timeline-border",
              prsMoveColorBorder: "job-timeline-border",
              prsActive: true,
              journeyLine:true
            };
          }
        } else if (ress.index === 1) {
          if (
            !formRef.current.dirty ||
            formErrorKeys["resume"]
          ) {
            return {
              ...ress,
              currentPage: false,
              currentPageStyle: "current-page",
              completedPage: false,
              prsActive: true,
              prsMoveColor: "",
              journeyLine:true
            };
          } else {
            return {
              ...ress,
              currentPage: false,
              currentPageStyle: "current-page",
              completedPage: true,
              prsMoveColor: "",
              prsMoveColorBorder: ress?.prsActive ? "" : "",
              prsActive: true,
              journeyLine:true
            };
          }
        } else if (ress.index === 2) {
          if (isCustomFormInvalid) {
            return {
              ...ress,
              currentPage: true,
              currentPageStyle: "",
              completedPage: false,
              prsMoveColor: "",
              prsMoveColorBorder: ress?.prsActive ? "" : "",
              prsActive: true,
              journeyLine:false
            };
          } 
          else {
            return {
              ...ress,
              currentPage: true,
              currentPageStyle: "",
              completedPage: true,
              prsMoveColor: "",
              prsMoveColorBorder: ress?.prsActive ? "" : "",
              prsActive: true,
              journeyLine:false
            };
          }
        }
        // }
      } else if (index === 0) {
        if (ress.index === 0) {
          if (
            !formRef.current.dirty ||
            formErrorKeys["title"] ||
            formErrorKeys["firstName"] ||
            formErrorKeys["lastName"] ||
            formErrorKeys["country"] ||
            formErrorKeys["phone"] ||
            formErrorKeys["emailAddress"] ||
            formErrorKeys["state"]
          ) {
            return {
              ...ress,
              currentPage: true,
              currentPageStyle: "current-page",
              completedPage: false,
              prsActive: true,
              prsMoveColor: "",
              prsComColorBorder: "#3A3E54",
              journeyLine: (ress.journeyLine && timeListData[1].completedPage) ? true : false
            };
          } else {
            return {
              ...ress,
              currentPage: true,
              currentPageStyle: "current-page",
              completedPage: true,
              prsMoveColor: "",
              prsMoveColorBorder: "",
              prsActive: true,
              journeyLine: (ress.journeyLine && timeListData[1].completedPage) ? true : false
            };
          }
        } else if (ress.index === 1) {
          if (
            !formRef.current.dirty ||
            formErrorKeys["resume"]
          ) {
            return {
              ...ress,
              currentPage: false,
              currentPageStyle: "current-page",
              completedPage: false,
              prsActive: true,
              prsMoveColor: "",
              prsComColorBorder: "",
              journeyLine: (timeListData[2] && timeListData[2].completedPage) ? true : false
            };
          } else {
            return {
              ...ress,
              currentPage: false,
              currentPageStyle: "",
              completedPage: true,
              prsMoveColor: "",
              prsMoveColorBorder: ress?.prsActive ? "" : "",
              prsActive: true,
              journeyLine: (timeListData[2] && timeListData[2].completedPage) ? true : false
            };
          }
        } else if (ress.index === 2) {
          if(isCustomFormInvalid) {
            return {
              ...ress,
              currentPage: false,
              currentPageStyle: "",
              completedPage: false,
              prsMoveColor: "",
              prsMoveColorBorder: ress?.prsActive ? "" : "",
              prsActive: true,
              journeyLine:false
            };
          } 
          else {
            return {
              ...ress,
              currentPage: false,
              currentPageStyle: "",
              completedPage: true,
              prsMoveColor: "",
              prsMoveColorBorder: ress?.prsActive ? "" : "",
              prsActive: true,
              journeyLine:false
            };
          }
        }
      }
      return ress;
    });
  };

  const moveToNextForm = (index: number) => {
    // console.log(index);
    const formErrorKeys = Object.keys(formRef?.current?.errors);
    const formOneKeys = [
      "title",
      "firstName",
      "lastName",
      "phone",
      "emailAddress",
      "state",
    ];

    // console.log(formErrorKeys);

    if (timeListData[index]?.index === 0) {
      // console.log("if", updateFormData[index]);
      window.scrollTo(0, 0);
      // if (commonKeys?.length === 0) {
      setTimeLineData(updateTimeLine(timeListData, index));
      // }
    } else if (timeListData[index]?.index === 1) {
      // const formOneKeys = ["resume"];
      // const commonKeys = formOneKeys.filter(key => formErrorKeys.includes(key));
      jobDataDiv?.current?.offsetHeight !== undefined ? 
        window.scrollTo(
          0,
          contactDetails?.current?.offsetHeight +
          jobDataDiv?.current?.offsetHeight +
          70
        )
        : window.scrollTo(
          0,
          contactDetails?.current?.offsetHeight +
          FormDataDiv?.current?.offsetTop - 50
        );
      // if (commonKeys?.length > 0) {
      setTimeLineData(updateTimeLine(timeListData, index));
      // }
    } else {
      // console.log("else", timeListData[index]);
      jobDataDiv?.current?.offsetHeight !== undefined ? 
      window.scrollTo(
        0,
        contactDetails?.current?.offsetHeight +
        jobDataDiv?.current?.offsetHeight +
        documentationDiv?.current?.offsetHeight +
        100
      )
        : window.scrollTo(
          0,
          contactDetails?.current?.offsetHeight +
          FormDataDiv?.current?.offsetTop +
          documentationDiv?.current?.offsetHeight -
          20
        );
      setTimeLineData(updateTimeLine(timeListData, index));
    }
  };
  let count = 0;
  const getformStatus = (e: any, isFileUploaded?: boolean) => {

    // const formErrorKeys = Object.keys(formRef?.current?.errors);
    const formErrorKeys: any = formRef?.current?.errors;
    // console.log(formErrorKeys);

    // const formOneKeys = ["title", "firstName", "lastName", "country", "phone",
    // "emailAddress", "state", "post_code"];
    // const commonKeys = formOneKeys.filter(key => !formErrorKeys.includes(key));
    // console.log(commonKeys);
    if (Object.keys(formErrorKeys).length > 0) {
      setTimeout(() => {
        if (isFileUploaded) {
          setTimeLineData(updateTimeLine(timeListData, 1));
        }
        else {
          setTimeLineData(updateTimeLine(timeListData, 0));
        }
      },1);
      // if (formErrorKeys["resume"] && formErrorKeys["resume"] !== null) {
      //     setTimeLineData(updateTimeLine(timeListData, 1));

      // }
    }
    //  else {
    //   setTimeLineData(timeLineInData);
    // }

    // if (commonKeys?.length === 0) {
    //     setTimeLineData(updateTimeLine(timeListData, 0));
    // }
    // else if(commonKeys?.length > 0){
    //     const formOneKeys = ["resume"];
    //     const commonKeys = formOneKeys.filter(key => formErrorKeys.includes(key));
    // }
  };

  const checkCustomValidationErrors = () => {
    /**
     * Checks custom form builder-form for validation errors
     * only checks if the entire form is dirty and custom form elements are touched atleast once
     */
    if (formRef.current?.dirty) {
      let isInvalid;
      setTimeout(() => {
        isInvalid = Object.keys(formRef.current.errors).some((field: any) => (customFormRequiredFields.includes(field)));
        setCustomFormValidity(isInvalid);
      }, 1);
    }
  };

  useEffect(() => {
    if (formRef.current.dirty) {
      setTimeLineData(updateTimeLine(timeListData, 2));
    }
  }, [isCustomFormInvalid]);

  const fieldValidation = (value: any) => {    
    let error;
    checkCustomValidationErrors();
    if (typeof value === "string") {
      if (!value.trim()) {
        error = "This field is required";
      } else if (htmlTagPattern.test(value)) {
        error = t("Links and HTML aren't allowed in this field");
      }
    } else if (Array.isArray(value)) {
      if (value.length === 0) {
        error = "This field is required";
      }
    }

    return error;
  };

  // console.log(observedDiv?.current?.offsetHeight , submitButtonRef?.current?.offsetHeight , dynamikFormDataRef?.current?.offsetHeight);
  // console.log(observedDiv?.current?.offsetHeight , submitButtonRef?.current?.offsetHeight , dynamikFormDataRef?.current?.offsetHeight);

  const asyncFileUpdate = () => {
    /**
     *  Implementation due to direct DOM manipulation, checks if there is a file uploaded into resume section
     */
    setTimeout(() => {
      getformStatus(null, true);
    }, 1);
  };

  const parseTNC = () => {
    //Terms and conditions builder, uses dangerouslyset for dynamic links
    let clientConfigData:any = clientConfig?.data?.data?.clientSettings;
    let modifiedTerms = clientConfigData?.terms?.text;    
    let linkString1 = `<a target="_blank" href="${clientConfigData?.terms.link1Url}">${clientConfigData?.terms.link1Text}</a>`;
    let linkString2 = `<a target="_blank" href="${clientConfigData?.terms.link2Url}">${clientConfigData?.terms.link2Text}</a>`;
    let linkString3 = `<a target="_blank" href="${clientConfigData?.terms.link3Url}">${clientConfigData?.terms.link3Text}</a>`;
    modifiedTerms = modifiedTerms?.replace("link1", linkString1);
    modifiedTerms = modifiedTerms?.replace("link2", linkString2);
    modifiedTerms = modifiedTerms?.replace("link3", linkString3);
    return (
      <>
        <label htmlFor="tAndC" dangerouslySetInnerHTML={{__html: modifiedTerms}}></label>
      </>
    );
  };

  const removeFile = (name: string, formik: any) => {
    const removeData: any = document.getElementById(name);
    if (removeData) {
      removeData.value = null;
      formik?.setFieldValue(name, null);
      asyncFileUpdate();
    }
  };

  useEffect(() => {
    if(questionOpenAndClose === false){
      setQaShowHide("qahide");
    } else {
      setQaShowHide("qashow");
    }
  }, [questionOpenAndClose]);

  const getSummaryReference: any = (errorRef: any, customLabelData: any) => {    
    let finalErrorData: any = [];
    let customErrorData: any = []; //NEW: to store custom label errors separately

    let uniqueErrorArray: any;

    for (let key of Object.keys(errorRef)) {
      let isCustomHandled = false; //NEW: to track if key is handled in custom

      if (customLabelData && customLabelData.length > 0) {
        customLabelData.forEach((element: any) => {
          if (element.fieldId === key.toString()) {
            customErrorData.push({ //CHANGE: push to customErrorData
              errorLabel: t("QuestionErrorMsg", { fieldname: element.label }),
            });
            isCustomHandled = true;
          }
        });
      }

      // MOVE: push default error only if not handled in custom
      if (!isCustomHandled) {
        finalErrorData.push({ errorLabel: errorRef[key] });
      }
    }

    // COMBINE: default errors first, custom errors after
    //reverse customErrorData to make sure they are in correct order
    // customErrorData = customErrorData.reverse();
    finalErrorData = [...finalErrorData, ...customErrorData];

    // Formik's current implementation creates duplicates of errors, this is a fix for that problem, the below operation won't be required once that part is optimized/fixed
    uniqueErrorArray = finalErrorData.filter(
      (object: any, index: any) =>
        index ===
        finalErrorData.findIndex(
          (obj: any) => JSON.stringify(obj) === JSON.stringify(object)
        )
    );

    return uniqueErrorArray;
  };


  const FilterHtmlTags = (htmlString:any) => {
    const regex = /(<([^>]+)>)/gi;
    const plainString = htmlString.replace(regex, " ");
    return plainString;
  };
  const ErrorSummary = (props:any) => {
    const { errors } = props;
    let errorMap:any = [];
    if(Object.keys(errors).length > 0) {
      errorMap = getSummaryReference(errors, customFormRequiredReference);
    }
    return (    
      <>
      { (errorMap.length > 0) &&
        <div className="error-summary card custom-card p-3">
          <h2 className="error-message">{t("There were some errors in your job application, please fix them to proceed with the application submission process")}</h2>
          <ul>
          {
            errorMap.map((err:any, i: number) => {
              return (
                <>
                  <li className="error-message" key={i}>{`${t(FilterHtmlTags(err.errorLabel))}`}</li>
                </>
              );
            })
          }
          </ul>
        </div>
        }
      </>  
    );
  };
  //clears secondary subcategory selectionss on hitting the X button
  const onClearPrimaryCategory = (formikHook:any) => {
    setSelectedCategoryDropdown({
      parentCategoryId: null,
      depdropdown: null
    });
    setCurrentSelectedCategoryPair({
      categoryId: null,
      categoryLabel : null,
      subCategoryId : null,
      subcategoryLabel : null
    });
    formikHook.setFieldValue("interestprimarycategory", "");
    formikHook.setFieldValue("interestsubcategories", "");
  };

  //clears secondary subcategory selections on hitting the X button
  const onClearSubCategory = (formikHook:any) => {
    setCurrentSelectedCategoryPair({
      ...currentSelectedCategoryPair,
      subCategoryId : null,
      subcategoryLabel : null
    });
    formikHook.setFieldValue("interestsubcategories", "");
  };

  const findExistingCategoryPairs = (pairToCheck:any) =>{
    let returnObject:any = {
      existingPairs : [],
      errStatus: ""
    };
    returnObject.existingPairs = addedCategoryReferenceList.filter((entry:any) => {
        return Object.keys(pairToCheck).every((key:any) => {
          //if the new pair has an empty sub category, check for other existing entries with the same parent category
          if(pairToCheck.subCategoryId === null) {
            returnObject.errStatus = "You have already selected the main interest, please remove that to add sub interests separately";
            return (entry.categoryId === pairToCheck.categoryId);
          }
          // if adding pair doesnt have an empty sub category, check for unique pairs or existing emptys
          else{
            returnObject.errStatus = "You have already selected this interest, please choose another";
            return (entry[key] === pairToCheck[key]) || (entry.categoryId === pairToCheck.categoryId && entry.subCategoryId === null);
          }            
        });
    });    

    return returnObject;
  };

  //Returns all pairs that are not the provided pair, to be used for post deletion state update
  const filteredCategoryPair = (pairToRemove:any) =>{
    let filteredList:any = [];
    addedCategoryReferenceList.forEach((item:any) => {      
       if((item.categoryId !== pairToRemove.categoryId) || (item.subCategoryId !== pairToRemove.subCategoryId)) {
        filteredList.push(item);
       }
    });
    return filteredList;
  };

  //Dependent dropdown parent category change event
  const onSelectCategory = (formikAccess: any, dropdownRef: any, parentCategoryId: any, questions: any) => {
    //sets the sub category dropdown values based off parent    
    setSelectedCategoryDropdown({
      parentCategoryId: parentCategoryId,
      depdropdown : questions[0]?.depdropdown
    });
    //manually sets selected category and first subcategory as a pair ready to insert
    setCurrentSelectedCategoryPair({
      categoryId: parentCategoryId,
      categoryLabel : questions[0]?.label,
      subCategoryId : null,
      subcategoryLabel : null
    });
    formikAccess.setFieldValue(dropdownRef, parentCategoryId);
  };

  //Dependent dropdown child category change event
  const onSelectSubCategory = (formikAccess: any, selectRef: any, value: any, subQuestions: any) => {
    formikAccess.setFieldValue(selectRef, value);
    setCurrentSelectedCategoryPair({
      ...currentSelectedCategoryPair,
      subCategoryId : value ? value : null,
      subcategoryLabel : value ? subQuestions.find((e:any) => e.attributes.id === value).value: null
    });
  };

  //Add interest to the right side button event
  const addInterest = (formikAcceess: any, parentCategoryArray: any) => {
    let existingPairFinder:any = {};
    //Empty pair values check before adding (for form init)
    if((currentSelectedCategoryPair.categoryId && currentSelectedCategoryPair.categoryId !== "") && Object.keys(currentSelectedCategoryPair).length > 0){
      existingPairFinder = findExistingCategoryPairs(currentSelectedCategoryPair);
      if(!(existingPairFinder.existingPairs.length > 0)) {
        //setting a hidden variable alongside for formik's internal validator, TODO: clean up with a better setup
        let categoryRef = [...addedCategoryReferenceList,currentSelectedCategoryPair];        
        setCategoryReferenceList(categoryRef);
        formikAcceess.setFieldValue("categoryList", categoryRef);
        formikAcceess.setStatus({message : null});
      }
      else{
        formikAcceess.setStatus({message : existingPairFinder.errStatus});
      }
    }
    else{
      formikAcceess.setStatus({message : "Please select an option before adding"});
    }
  };

  //Delete button action for removing category pairs
  //TODO
  const removeCategoryPair = (formikAccess: any, pair:any) => {
    let categoryRef = filteredCategoryPair(pair);
    //setting a hidden variable alongside for formik's internal validator, TODO: clean up with a better setup
    setCategoryReferenceList(categoryRef);
    formikAccess.setFieldValue("categoryList", categoryRef);
    formikAccess.setFieldTouched("categoryList", true);
  };
  
  return (
    <>
      {jobDetails.status === 200 && jobDetails?.data?.statusCode === 200 ? (
        <>
          <div>{/* <Loader loading={loader} /> */}</div>
          { showSearchFilter ? jobFilterData() : "" }
          <div className= { `container-fluid subheader-3 d-none ${subHeaderStyle}`}>
            <>
              <div className="row">
                <div className="col-md-6 col-lg-6 col-12 col-sm-12  ">
                  <div className="d-none d-sm-none d-md-block">
                    <p className="page-heading mb-0 page-heading-img">
                      {
                        (clientSiteSettings?.templateName === "template_4") ?
                        <>
                          <button onClick={redirectListing}>
                            <Image src={zealLogo} alt="Zeal Logo" />
                          </button>
                        </>
                        : ""
                      }
                      Job Application
                    </p>
                  </div>
                </div>
                <div className="col-md-6 col-lg-6 col-12 col-sm-12 d-flex justify-content-sm-center justify-content-center justify-content-md-end pe-auto d-none">
                  <div className="careers-timeline careers-timeline-new">
                    <div className="d-flex align-items-center justify-content-center justify-content-md-end">
                      {/* <div className="careers-timeline  careers-timeline-new"> */}
                      <div className="d-flex align-items-center justify-content-center justify-content-md-end">
                        <div className="timeline-scroll timeline-scroll-new">
                          {timeListData.map((ress, i: number) => {
                            return (
                              <React.Fragment key={ress.label}>
                                <div className="d-flex">
                                  <div
                                    key={ress.label}
                                    className="d-flex align-items-center1 time-line"
                                  >
                                    {/* <OverlayTrigger placement="bottom" overlay={<Tooltip>{ress.label}</Tooltip>}> */}
                                    <div
                                      role={"button"}
                                      onClick={() => moveToNextForm(ress.index)}
                                      className={`time-line-circle ${ress.currentPageStyle} ${ress.prsMoveColor}`}
                                    >
                                      <div
                                        role="button"
                                        className={"time-line-label"}
                                      >
                                        <span
                                          className={i === 1 ? "doc-label" : ""}
                                        >
                                          {ress.label}
                                        </span>
                                      </div>
                                      {ress.currentPage ? (
                                        <div className="time-line-inner-outer">
                                          <div className="time-line-inner-outer-par">
                                            <div className="time-line-inner-circle"></div>
                                          </div>
                                        </div>
                                      ) : (
                                        ""
                                      )}
                                      {ress.completedPage ? (
                                        <>
                                          <div className="time-line-inner-outer">
                                            <div className="time-line-inner-outer-par">
                                              <div
                                                className={"time-line-inner-circle d-none"}
                                              ></div>
                                              <i
                                                className={"pi pi-check timeline-done"}
                                              ></i>
                                            </div>
                                          </div>
                                        </>
                                      ) : (
                                        ""
                                      )}
                                    </div>

                                    {i + 1 !== timeListData.length ? (
                                      <>
                                        {ress?.journeyLine ? (
                                          <div
                                            className={"current-page-bar"}
                                            style={{
                                              minWidth: "115px",
                                              height: "2px",
                                            }}
                                          ></div>
                                        ) : (
                                          <div
                                            style={{
                                              minWidth: "115px",
                                              height: "2px",
                                              background: "#BBBBBB",
                                            }}
                                          ></div>
                                        )}
                                      </>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                </div>
                              </React.Fragment>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                  <br />
                </div>
              </div>
              <br />
            </>
          </div>

          <div
            id="overAllSection"
            ref={overAllSection}
            className={`container-fluid pt-4 ${jobBodyStyle} position-relative mobile-screen-padd-bot custom-job-apply-container`}
          >
            <div className="container">
              {viewJobControl && clientConfig?.data?.data?.clientSettings?.isMicroSite !== 1  ? (
                <Button
                  onClick={() => jobPreView()}
                  type="button"
                  icon={
                    jobPreViewSection ? "pi pi-arrow-right" : "pi pi-arrow-left"
                  }
                  position="left"
                  label={jobPreViewSection ? t("Close Job Ad") : jobApplyLangLabels?.previewJobAd}
                  clasName={`btn btn-primary completion-btn-primary btn-custom-moving ${jobPreViewSection ? "btn-control-view" : ""
                    }`}
                />
              ) : (
                ""
              )}
              <div className="row" ref={observedDiv}>
                {viewJobControl && clientConfig?.data?.data?.clientSettings?.isMicroSite !== 1  ? (
                  <>
                    { (showLink && showSearchFilter) ? 
                      <div className="module-careers-listings">
                        <div className="flex">
                          <div className="job-view">
                            <div className="job-detail p-0 bg-transparent">
                              <div className="backtolisting">
                                <button type="button" className="arrow prev" onClick={redirectListing}>
                                    <span className="icon">
                                        <Image src={ArrowLeft} alt="arrow" />
                                    </span>
                                    <h6 className="mb-0">{t("BACK TO LISTINGS")}</h6>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    : showLink ? 
                    <div className="mb-3">
                      <button className="btn btn-primary completion-btn-primary" onClick={redirectListing}><i className="pi pi-arrow-left me-2"></i>{t("BACK TO LISTINGS")}</button>
                    </div>
                    :
                      ""
                    }
                    <div
                      ref={jobDataDiv}
                      className="col-xl-6 col-lg-10 col-md-10 col-sm-10 col-12"
                    >
                      
                    </div>
                    <div className="col-lg-6 col-md-2 col-sm-2 col-0"></div>
                  </>
                ) : (
                  ""
                )}
                <div
                  ref={FormDataDiv}
                  className={`mobil-button-div ${jobPreViewSection ? "col-md-6" : "col-md-12"
                    }`}
                >

                  {/*job title */}
                  {
                    clientConfig?.data?.data?.clientSettings?.jobTitle.length > 0 ? (
                      <div className="head-title">{clientConfig?.data?.data?.clientSettings?.jobTitle}</div>
                    ) : "" }

                  {/*job detail */}
                  {
                    clientConfig?.data?.data?.clientSettings?.staticJobDescription.length > 0 ? (

                      <div
                            className="com-html-text"
                            dangerouslySetInnerHTML={{
                              __html: clientConfig?.data?.data?.clientSettings?.staticJobDescription,
                            }}
                          ></div>
                     

                    ) : ""
                  }
                  {Object.keys(jobApplyForm).length > 0 ? (
                                      <Formik
                                        initialValues={jobApplyForm}
                                        validationSchema={validateSchema}
                                        enableReinitialize
                                        onSubmit={(values) => {
                                          submitApplayJob(values);
                                        }}
                                        innerRef={(f) => (formRef.current = f)}
                                      >
                                        {(formik) => (
                                          // console.log(formik),
                                          // {Object.keys(formik?.errors)?.length?getformStatus(formik):""},
                                          // ,                        
                                          <Form>
                                            {/* <ScrollToError/> */}
                                            <div className="form-space job-apply">
                                              <div ref={contactDetails} className="job-apply-parent">
                                                <div
                                                  className={`${jobPreViewSection ? "job-apply-section" : "job-apply-section"
                                                    }`}
                                                >
                                                  <h3 className="adres-form-heading">
                                                    {t("Contact Details")}
                                                  </h3>
                                                  <div className={`${jobPreViewSection ? "job-apply-section-inner preview-job-ads" : "job-apply-section-inner"}`}>
                                                    {jobFormSettings?.showTitle === 1 ? (
                                                      <>
                                                        <div className={"job-apply-list first-section "}>
                                                          <Label
                                                            name="title"
                                                            className="form-label"
                                                            label={TitleLabel}
                                                            required={jobFormSettings?.isTitleMandatory === 1 ? true : false}
                                                          />
                                                          <SingleSelect
                                                            className="form-control-select form-control"
                                                            placeholder={t("Select ")+ TitleLabel?.toLowerCase() + "..."}
                                                            // value={tableControl.pageSize}
                                                            onChange={(e: any) => {
                                                              formik.setFieldValue("title", e.value);
                                                              }}
                                                            onInputChange={(e: any) => {
                                                              getformStatus(formik);
                                                            }}
                                                            options={titleList}
                                                            isSearchable={false}
                                                          /> 
                                                          <ErrorMessage
                                                            name={"title"}
                                                            component={TextError}
                                                          />
                                                        </div>
                                                      </>
                                                    ) : ""}
                  
                                                    {jobFormSettings?.showFirstName === 1 ? (
                                                      <>
                                                        <div className={"job-apply-list"}>
                                                          <Label
                                                            name="firstName"
                                                            className="form-label"
                                                            label={FirstNameLabel}
                                                            required={jobFormSettings?.isFirstNameMandatory === 1 ? true : false}
                                                          />                                    
                                                          <Field
                                                            as={"input"}
                                                            onKeyDown={(e: any) =>
                                                              getformStatus(formik)
                                                            }
                                                            placeholder={t("Enter ")+ FirstNameLabel?.toLowerCase() + "..."}
                                                            name={"firstName"}
                                                            id={"firstName"}
                                                            className="form-control"
                                                            onBlur={(e: any) => e.preventDefault()}
                                                          ></Field>
                                                          <ErrorMessage
                                                            name={"firstName"}
                                                            component={TextError}
                                                          />
                                                        </div>
                                                      </>
                                                    ) : "" }
                  
                  
                                                    {jobFormSettings?.showLastName === 1 ? (
                                                      <>
                                                        <div className={"job-apply-list "}>
                                                          <Label
                                                            name="lastName"
                                                            className="form-label"
                                                            label={LastNameLabel}
                                                            required={jobFormSettings?.isLastNameMandatory === 1 ? true : false}
                                                          />
                                                        
                                                          <Field
                                                            as={"input"}
                                                            placeholder={t("Enter ") + LastNameLabel?.toLowerCase() + "..."}
                                                            name={"lastName"}
                                                            id={"lastName"}
                                                            className="form-control"
                                                            onKeyDown={(e: any) =>
                                                              getformStatus(formik)
                                                            }
                                                            onBlur={(e: any) => e.preventDefault()}
                                                          ></Field>
                                                          <ErrorMessage
                                                            name={"lastName"}
                                                            component={TextError}
                                                          />
                                                        </div>
                                                      </>
                                                    ) : "" }
                  
                                                    {jobFormSettings?.showPreferredName === 1 ? (
                                                      <>
                                                        <div className={"job-apply-list "}>
                                                          <Label
                                                            name="preferredName"
                                                            className="form-label"
                                                            label={PreferredNameLabel}
                                                            required={jobFormSettings?.isPreferredNameMandatory === 1 ? true : false}
                                                          />
                                                          <Field
                                                            as={"input"}
                                                            placeholder={t("Enter ") + PreferredNameLabel?.toLowerCase() + "..."}
                                                            name={"preferredName"}
                                                            id={"preferredName"}
                                                            className="form-control"
                                                            onKeyDown={(e: any) =>
                                                              getformStatus(formik)
                                                            }
                                                            onBlur={(e: any) => e.preventDefault()}
                                                          ></Field>
                                                          <ErrorMessage
                                                            name={"preferredName"}
                                                            component={TextError}
                                                          />
                                                        </div>
                                                      </>
                                                    ) : "" }
                  
                                                    {jobFormSettings?.showMobile === 1 ? (
                                                      <>
                                                        <div className={"job-apply-list "}>
                                                          <Label
                                                            name="phone"
                                                            className="form-label"
                                                            label={MobileLabel}
                                                            required={jobFormSettings?.isMobileMandatory === 1 ? true : false}
                                                          />
                                                          <Field
                                                            as={"input"}
                                                            placeholder={t("Enter ")+ MobileLabel?.toLowerCase() + "..."}
                                                            name={"phone"}
                                                            id={"phone"}
                                                            className="form-control"
                                                            onKeyDown={(e: any) =>
                                                              getformStatus(formik)
                                                            }
                                                            onBlur={(e: any) => e.preventDefault()}
                                                          ></Field>
                                                          <ErrorMessage
                                                            name={"phone"}
                                                            component={TextError}
                                                          />
                                                        </div>
                                                      </>
                                                    ) : "" }
                  
                                                    {jobFormSettings?.showEmail === 1 ? (
                                                      <>
                                                        <div className={"job-apply-list "}>
                                                          <Label
                                                            name="emailAddress"
                                                            className="form-label"
                                                            label={EmailLabel}
                                                            required={jobFormSettings?.isEmailMandatory === 1 ? true : false}
                                                          />
                                                          <Field
                                                            as={"input"}
                                                            type="email"
                                                            placeholder={t("Enter ") + EmailLabel?.toLowerCase() + "..."}
                                                            name={"emailAddress"}
                                                            id={"emailAddress"}
                                                            className="form-control"
                                                            onKeyDown={(e: any) =>
                                                              getformStatus(formik)
                                                            }                                          
                                                            onBlur={(e: any) => e.preventDefault()}
                                                          ></Field>
                                                          <ErrorMessage
                                                            name={"emailAddress"}
                                                            component={TextError}
                                                          />
                                                        </div>
                                                      </>
                                                    ) : "" }
                  
                                                    {jobFormSettings?.showLinkedin === 1 ? (
                                                      <>
                                                        <div className={"job-apply-list "}>
                                                          <Label
                                                            name="linkedinProfile"
                                                            className="form-label"
                                                            label={LinkedinProfileLabel}
                                                            required={jobFormSettings?.isLinkedinMandatory === 1 ? true : false}
                                                          />
                                                          <Field
                                                            as={"input"}
                                                            type="text"
                                                            placeholder={t("Enter ") + LinkedinProfileLabel.toLowerCase() + "..."}
                                                            name={"linkedinProfile"}
                                                            id={"linkedinProfile"}
                                                            className="form-control"
                                                            onKeyDown={(e: any) =>
                                                              getformStatus(formik)
                                                            }
                                                            onBlur={(e: any) => e.preventDefault()}
                                                          ></Field>
                                                          <ErrorMessage
                                                            name={"linkedinProfile"}
                                                            component={TextError}
                                                          />
                                                        </div>
                                                      </>
                                                    ) : "" }
                                                  </div>
                                                </div>
                                                {/* <div
                                                  className={`${jobPreViewSection ? "col-md-0" : "d-none"
                                                    }`}
                                                ></div> */}
                                                
                                                { jobFormSettings?.showResidentialAddress === 1 ? (
                                                  <>
                                                    <div
                                                      ref={residentialAddress}
                                                      className={`${jobPreViewSection ? "job-apply-section" : "job-apply-section"
                                                        }`}
                                                    >
                                                      <h3 className="adres-form-heading">
                                                      {jobApplyLangLabels?.residentialAddress}
                                                      </h3>
                                                      <div className={`${jobPreViewSection ? "job-apply-section-inner preview-job-ads" : "job-apply-section-inner"}`}>
                                                        
                                                        {jobFormSettings?.showAddress1 === 1 ? (
                                                            <>
                                                              <div className={"job-apply-list"}>
                                                                <Label
                                                                  name="address_1"
                                                                  className="form-label"
                                                                  label= {Address1Label}
                                                                  required={jobFormSettings?.isAddress1Mandatory === 1 ? true : false}
                                                                />
                                                                <Field
                                                                  as={"input"}
                                                                  placeholder={t("Enter ") + Address1Label?.toLowerCase() + "..."}
                                                                  name={"address_1"}
                                                                  id={"address_1"}
                                                                  className="form-control"
                                                                  onKeyDown={(e: any) =>
                                                                    getformStatus(formik)
                                                                  }
                                                                  onBlur={(e: any) => e.preventDefault()}
                                                                ></Field>
                                                                <ErrorMessage
                                                                  name={"address_1"}
                                                                  component={TextError}
                                                                />
                                                              </div>
                                                            </>
                                                        ) : "" }
                                                        
                                                        {jobFormSettings?.showAddress2 === 1 ? (
                                                            <>
                                                              <div className={"job-apply-list "}>
                                                                <Label
                                                                  name="address_2"
                                                                  className="form-label"
                                                                  label={Address2Label}
                                                                  required={jobFormSettings?.isAddress2Mandatory === 1 ? true : false}
                                                                />
                                                                <Field
                                                                  as={"input"}
                                                                  placeholder={t("Enter ") + Address2Label?.toLowerCase() + "..."}
                                                                  name={"address_2"}
                                                                  id={"address_2"}
                                                                  className="form-control"
                                                                  onKeyDown={(e: any) =>
                                                                    getformStatus(formik)
                                                                  }
                                                                  onBlur={(e: any) => e.preventDefault()}
                                                                ></Field>
                                                                <ErrorMessage
                                                                  name={"address_2"}
                                                                  component={TextError}
                                                                />
                                                              </div>
                                                            </>
                                                        ) : "" }
                                                        {jobFormSettings?.showCity === 1 ? (
                                                          <>
                                                            <div className={"job-apply-list "}>
                                                              <Label
                                                                name="suburb_city"
                                                                className="form-label"
                                                                label={CityLabel}
                                                                required={jobFormSettings?.isCityMandatory === 1 ? true : false}
                                                              />
                                                              <Field
                                                                as={"input"}
                                                                placeholder={t("Enter ") + CityLabel?.toLowerCase() + "..."}
                                                                name={"suburb_city"}
                                                                id={"suburb_city"}
                                                                className="form-control"
                                                                onKeyDown={(e: any) =>
                                                                  getformStatus(formik)
                                                                }
                                                                onBlur={(e: any) => e.preventDefault()}
                                                              ></Field>
                                                              <ErrorMessage
                                                                name={"suburb_city"}
                                                                component={TextError}
                                                              />
                                                            </div>
                                                          </>
                                                        ) : "" }
                  
                  
                                                        {jobFormSettings?.showCountry === 1 ? (
                                                          <>
                                                            <div className={"job-apply-list"}>
                                                              <Label
                                                                name="country"
                                                                className="form-label"
                                                                label={CountryLabel}
                                                                required={jobFormSettings?.isCountryMandatory === 1 ? true : false}
                                                              />
                                                              <SingleSelect
                                                                className="form-control-select form-control"
                                                                placeholder={t("Select ") + CountryLabel?.toLowerCase() + "..."}
                                                                // value={tableControl.pageSize}
                                                                onChange={(e: any) => {
                                                                  formik.setFieldValue("country", "");
                                                                  formik.setFieldValue(
                                                                    "country",
                                                                    e?.value?.toString()
                                                                  ),
                                                                    getStatusList(e.value);
                                                                }}
                                                                onInputChange={(e: any) => {
                                                                  getformStatus(formik);
                                                                }}
                                                                isSearchable={true}
                                                                options={country}
                                                              />
                                                              <ErrorMessage
                                                                name={"country"}
                                                                component={TextError}
                                                              />
                                                            </div>
                                                          </>
                                                        ) : "" }
                  
                                                      {jobFormSettings?.showState === 1 ? (
                                                        <>
                                                          <div className={"job-apply-list "}>
                                                            <Label
                                                              name="state"
                                                              className="form-label"
                                                              label={StateLabel}
                                                              required={jobFormSettings?.isStateMandatory === 1 ? true : false}
                                                            />
                                                            <SingleSelect
                                                              className="form-control-select form-control"
                                                              placeholder={t("Select ") + StateLabel?.toLowerCase() + "..."}
                                                              // value={tableControl.pageSize}
                                                              onChange={(e: any) => {
                                                                formik.setFieldValue(
                                                                  "state",
                                                                  e.value?.toString()
                                                                );
                                                              }}
                                                              onInputChange={(e: any) => {
                                                                getformStatus(formik);
                                                              }}
                                                              options={states}
                                                              isSearchable={true}
                                                              value={
                                                                formik?.values["state"]
                                                                  ? states.filter(
                                                                    (ress: any) =>
                                                                      ress?.value ===
                                                                      formik?.values["state"]
                                                                  )[0]
                                                                  : ""
                                                              }
                                                            />                                    
                                                            <ErrorMessage
                                                              name={"state"}
                                                              component={TextError}
                                                            />
                                                          </div>
                                                        </>
                                                      ) : "" }
                                                      
                                                      {jobFormSettings?.showPostCode === 1 ? (
                                                        <>
                                                          <div className={"job-apply-list "}>
                                                            <Label
                                                              name="post_code"
                                                              className="form-label"
                                                              label={PostCodeLabel}
                                                              required={jobFormSettings?.isPostCodeMandatory === 1 ? true : false}
                                                            />
                                                            <Field
                                                              as={"input"}
                                                              placeholder={t("Enter ") + PostCodeLabel?.toLowerCase() + "..."}
                                                              name={"post_code"}
                                                              id={"post_code"}
                                                              className="form-control"
                                                              onKeyDown={(e: any) =>
                                                                getformStatus(formik)
                                                              }
                                                              onBlur={(e: any) => e.preventDefault()}
                                                            ></Field>
                                                            <ErrorMessage
                                                              name={"post_code"}
                                                              component={TextError}
                                                            />
                                                          </div>
                                                        </>
                                                      ) : "" }
                                                      </div>
                                                    </div>
                                                  </>
                                                ) : ""}
                                              
                                              </div>
                                              
                                              {/* <div id="documentation-section" > */}
                  
                                              {(jobFormSettings?.showCoverLetter === 1 || jobFormSettings?.showResume === 1 || jobFormSettings?.showAdditionalDoc === 1)  ? ( 
                                                <>
                                                  <hr />
                                                  <div
                                                    className={`${jobPreViewSection ? "col-6 preview-ads-card-documentation" : "col-12"
                                                      }`}
                                                    ref={documentationDiv}
                                                  >
                                                    <div>
                                                      <h3 className="adres-form-heading">
                                                      {jobApplyLangLabels?.documentation}
                                                      </h3>
                                                      <div className="d-flex align-items-center my-2">
                                                        <i className="pi pi-exclamation-circle"></i>
                                                        <div className="ms-2">
                                                        {jobApplyLangLabels?.sizeLimit}: {file_size_from_api} MB. {jobApplyLangLabels?.formatsAllowed}:&nbsp;
                                                           {getFileTypes(true)}
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div className="card custom-card p-3">
                                                      <div className="card-body px-0 py-4 py-sm-5 p-md-3">
                                                        {/* <div className="row"> */}
                                                        {/* <div className="col-md-12"> */}
                                                        <div className="custom-card-documentation">
                                                          <div
                                                            className={`${jobPreViewSection ? "custom-card-documentation-inner" : "custom-card-documentation-inner"
                                                              }`}
                                                          >
                                                            <div className="job-apply-doc-parent">
                                                              {jobFormSettings?.showResume === 1 ? (
                                                                <>
                                                                  <div
                                                                    className={`${jobPreViewSection
                                                                      ? "job-apply-doc-list"
                                                                      : "job-apply-doc-list"
                                                                      } ${resumeDragActive ? "drag-active-zone" : ""}`}
                                                                    onDragOver={(e: any) => { e.preventDefault(); e.stopPropagation(); setResumeDragActive(true); }}
                                                                    onDragEnter={(e: any) => { e.preventDefault(); e.stopPropagation(); setResumeDragActive(true); }}
                                                                    onDragLeave={(e: any) => { e.preventDefault(); e.stopPropagation(); if (!e.currentTarget.contains(e.relatedTarget as Node)) { setResumeDragActive(false); } }}
                                                                    onDrop={(e: any) => { e.preventDefault(); e.stopPropagation(); setResumeDragActive(false); const file = e.dataTransfer.files[0]; if (file) { formik.setFieldValue("resume", file); asyncFileUpdate(); } }}
                                                                    onClick={() => document.getElementById("resume")?.click()}
                                                                  >
                                                                    <div className="">
                                                                      <div
                                                                        className={`file-circle ${(formik?.values["resume"] || resumeDragActive) ? "befor-file-upload" : "befor-file-circle"}`}
                                                                      >
                                                                        {formik?.values["resume"] ? (
                                                                          <Image
                                                                            role="button"
                                                                            onClick={(e: any) => { e.stopPropagation(); removeFile("resume", formik); }}
                                                                            clasName="close-icon"
                                                                            src={CloseIcon}
                                                                          />
                                                                        ) : (
                                                                          ""
                                                                        )}
                                                                        <Image
                                                                          role="button"
                                                                          onClick={(e: any) => { e.stopPropagation(); document.getElementById("resume")?.click(); }}
                                                                          src={ResumeIcon}
                                                                          alt="Resume"
                                                                        />
                                                                        <div className="d-none">
                                                                          <Field
                                                                            name={"resume"}
                                                                            onBlur={(e: any) =>
                                                                              e.preventDefault()
                                                                            }
                                                                          >
                                                                            {({
                                                                              field,
                                                                              form: {
                                                                                setFieldValue,
                                                                                values,
                                                                              },
                                                                            }: any) => {
                                                                              const fileInput: any =
                                                                                document.getElementById(
                                                                                  "resume"
                                                                                );
                                                                              if (fileInput) {
                                                                                fileInput.value = null;
                                                                              }
                                                                              return (
                                                                                <>
                                                                                  <input
                                                                                    id={"resume"}
                                                                                    onBlur={(e: any) =>
                                                                                      e.preventDefault()
                                                                                    }
                                                                                    type="file"
                                                                                    onChange={(
                                                                                      e: any
                                                                                    ) => {
                                                                                      setFieldValue(
                                                                                        field.name,
                                                                                        e?.target
                                                                                          ?.files[0]
                                                                                      );
                                                                                      asyncFileUpdate();
                                                                                    }}
                                                                                    multiple={true}
                                                                                  />
                                                                                </>
                                                                              );
                                                                            }}
                                                                          </Field>
                                                                        </div>
                                                                      </div>
                                                                      <div className="text-center">
                                                                        <Label
                                                                          className="form-label"
                                                                          label={ResumeLabel}
                                                                          required={jobFormSettings?.isResumeMandatory === 1 ? true : false}
                                                                        />
                                                                        <div className="select-file-name">
                                                                          {formik?.values["resume"] !==
                                                                            null
                                                                            ? formik?.values["resume"][
                                                                            "name"
                                                                            ]
                                                                            : ""}
                                                                        </div>
                                                                        <ErrorMessage
                                                                          name={"resume"}
                                                                          component={TextError}
                                                                        />
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                </>
                                                              ) : ""}
                  
                                                              {jobFormSettings?.showCoverLetter === 1 ? (
                                                                <>
                                                                  <div
                                                                    className={`${jobPreViewSection
                                                                      ? "job-apply-doc-list"
                                                                      : "job-apply-doc-list"
                                                                      } ${coverLetterDragActive ? "drag-active-zone" : ""}`}
                                                                    onDragOver={(e: any) => { e.preventDefault(); e.stopPropagation(); setCoverLetterDragActive(true); }}
                                                                    onDragEnter={(e: any) => { e.preventDefault(); e.stopPropagation(); setCoverLetterDragActive(true); }}
                                                                    onDragLeave={(e: any) => { e.preventDefault(); e.stopPropagation(); if (!e.currentTarget.contains(e.relatedTarget as Node)) { setCoverLetterDragActive(false); } }}
                                                                    onDrop={(e: any) => { e.preventDefault(); e.stopPropagation(); setCoverLetterDragActive(false); const file = e.dataTransfer.files[0]; if (file) { formik.setFieldValue("coverLetter", file); asyncFileUpdate(); } }}
                                                                    onClick={() => document.getElementById("coverLetter")?.click()}
                                                                  >
                                                                    <div className="">
                                                                      <div
                                                                        className={`file-circle ${(formik?.values["coverLetter"] || coverLetterDragActive) ? "befor-file-upload" : "befor-file-circle"}`}
                                                                      >
                                                                        {formik?.values["coverLetter"] ? (
                                                                          <Image
                                                                            onClick={(e: any) => { e.stopPropagation(); removeFile("coverLetter", formik); }}
                                                                            clasName="close-icon"
                                                                            src={CloseIcon}
                                                                          />
                                                                        ) : (
                                                                          ""
                                                                        )}
                                                                        <Image
                                                                          role="button"
                                                                          onClick={(e: any) => { e.stopPropagation(); document.getElementById("coverLetter")?.click(); }}
                                                                          src={LetterIcon}
                                                                          alt="Cover Letter"
                                                                        />
                                                                        <div className="d-none">
                                                                          <Field
                                                                            name={"coverLetter"}
                                                                            onBlur={(e: any) =>
                                                                              e.preventDefault()
                                                                            }
                                                                          >
                                                                            {({
                                                                              field,
                                                                              form: {
                                                                                setFieldValue,
                                                                                values,
                                                                              },
                                                                            }: any) => {
                                                                              const fileInput: any =
                                                                                document.getElementById(
                                                                                  "coverLetter"
                                                                                );
                                                                              if (fileInput) {
                                                                                fileInput.value = null;
                                                                              }
                                                                              return (
                                                                                <>
                                                                                  <input
                                                                                    id={"coverLetter"}
                                                                                    onBlur={(e: any) =>
                                                                                      e.preventDefault()
                                                                                    }
                                                                                    type="file"
                                                                                    onChange={(
                                                                                      e: any
                                                                                    ) => {
                                                                                      setFieldValue(
                                                                                        field.name,
                                                                                        e?.target
                                                                                          ?.files[0]
                                                                                      );
                                                                                    }}
                                                                                    multiple={true}
                                                                                  />
                                                                                </>
                                                                              );
                                                                            }}
                                                                          </Field>
                                                                        </div>
                                                                      </div>
                                                                      <div className="text-center">
                                                                        <Label
                                                                          className="form-label"
                                                                          label={CoverLetterLabel}
                                                                          required={jobFormSettings?.isCoverLetterMandatory === 1 ? true : false}
                                                                        />
                                                                        <div className="select-file-name">
                                                                          {formik?.values[
                                                                            "coverLetter"
                                                                          ] !== null
                                                                            ? formik?.values[
                                                                            "coverLetter"
                                                                            ]["name"]
                                                                            : ""}
                                                                        </div>
                                                                        <ErrorMessage
                                                                          name={"coverLetter"}
                                                                          component={TextError}
                                                                        />
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                </>
                                                              ) : ""}
                                                              
                                                              {jobFormSettings?.showAdditionalDoc === 1 ? (
                                                                <>
                                                                  <div
                                                                    className={`${jobPreViewSection
                                                                      ? "job-apply-doc-list"
                                                                      : "job-apply-doc-list"
                                                                      } ${addDocDragActive ? "drag-active-zone" : ""}`}
                                                                    onDragOver={(e: any) => { e.preventDefault(); e.stopPropagation(); setAddDocDragActive(true); }}
                                                                    onDragEnter={(e: any) => { e.preventDefault(); e.stopPropagation(); setAddDocDragActive(true); }}
                                                                    onDragLeave={(e: any) => { e.preventDefault(); e.stopPropagation(); if (!e.currentTarget.contains(e.relatedTarget as Node)) { setAddDocDragActive(false); } }}
                                                                    onDrop={(e: any) => { e.preventDefault(); e.stopPropagation(); setAddDocDragActive(false); const file = e.dataTransfer.files[0]; if (file) { formik.setFieldValue("addDoc", file); asyncFileUpdate(); } }}
                                                                    onClick={() => document.getElementById("addDoc")?.click()}
                                                                  >
                                                                    <div className="">
                                                                      <div
                                                                        className={`file-circle ${(formik?.values["addDoc"] || addDocDragActive) ? "befor-file-upload" : "befor-file-circle"}`}
                                                                      >
                                                                        {formik?.values["addDoc"] ? (
                                                                          <Image
                                                                            onClick={(e: any) => { e.stopPropagation(); removeFile("addDoc", formik); }}
                                                                            clasName="close-icon"
                                                                            src={CloseIcon}
                                                                          />
                                                                        ) : (
                                                                          ""
                                                                        )}
                                                                        <Image
                                                                          role="button"
                                                                          onClick={(e: any) => { e.stopPropagation(); document.getElementById("addDoc")?.click(); }}
                                                                          src={LetterIcon}
                                                                          alt="Resume"
                                                                        />
                                                                        <div className="d-none">
                                                                          <Field
                                                                            name={"addDoc"}
                                                                            onBlur={(e: any) =>
                                                                              e.preventDefault()
                                                                            }
                                                                            
                                                                            
                                                                          >
                                                                            {({
                                                                              field,
                                                                              form: {
                                                                                setFieldValue,
                                                                                values,
                                                                              },
                                                                            }: any) => {
                                                                              const fileInput: any =
                                                                                document.getElementById(
                                                                                  "addDoc"
                                                                                );
                                                                              if (fileInput) {
                                                                                fileInput.value = null;
                                                                              }
                                                                              return (
                                                                                <>
                                                                                  <input
                                                                                    id={"addDoc"}
                                                                                    onBlur={(e: any) =>
                                                                                      e.preventDefault()
                                                                                    }
                                                                                    type="file"
                                                                                    onChange={(
                                                                                      e: any
                                                                                    ) => {
                                                                                      setFieldValue(
                                                                                        field.name,
                                                                                        e?.target
                                                                                          ?.files[0]
                                                                                      );
                                                                                    }}
                                                                                    multiple={true}                                                                  
                                                                                    name={"addDoc"}
                                                                                  />
                                                                                </>
                                                                              );
                                                                            }}
                                                                          </Field>
                                                                        </div>
                                                                      </div>
                                                                      <div className="text-center">
                                                                        <Label
                                                                          className="form-label"
                                                                          label={AdditionalDocumentationLabel}
                                                                          required={jobFormSettings?.isAdditionalDocRequired === 1 ? true : false}
                                                                        />
                                                                        <div className="select-file-name">
                                                                          {formik?.values["addDoc"] !==
                                                                            null
                                                                            ? formik?.values["addDoc"][
                                                                            "name"
                                                                            ]
                                                                            : ""}
                                                                        </div>
                                                                        <ErrorMessage
                                                                          name={"addDoc"}
                                                                          component={TextError}
                                                                        />
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                </>
                                                              ) : ""}
                  
                                                            </div>
                                                          </div>
                                                        </div>
                                                        {/* </div> */}
                  
                                                        {/* </div> */}
                                                      </div>
                                                    </div>
                                                  </div>
                                                </>
                                              ) : "" }
                                              {jobDetails !== null &&
                                                jobDetails?.data?.data?.job?.questions?.length >
                                                0 ? (
                                                <hr />
                                              ) : (
                                                ""
                                              )}
                  
                                              <div
                                                className={`${jobPreViewSection ? "col-md-6 question-section" : "col-md-12 question-section"
                                                  }`}
                                              >
                                                {(jobDetails !== null &&
                                                  jobDetails?.data?.data?.job?.questions?.length >
                                                  0) ||
                                                  Object.keys(profileQuestion)?.length > 0 ? (
                                                  <div
                                                    ref={dynamikFormDataRef}
                                                    className="questions-head d-flex d-sm-flex mt-4 pt-2  d-md-flex mb-sm-3 mb-3 mb-md-2"
                                                  >
                                                    {questionOpenAndClose &&
                                                      (jobDetails?.data?.data?.job?.questions
                                                        ?.length > 0 ||
                                                        Object.keys(profileQuestion)?.length >
                                                        0) ? (
                                                      // <div role="button" onClick={() => setQuestionOpenAndClose(false)}>
                                                      //     <Image src={QuestionsOpenIcon} clasName="mb-1" />
                                                      // </div>
                                                      <div
                                                        role="button"
                                                        onClick={() =>
                                                          setQuestionOpenAndClose(false)
                                                        }
                                                        className={hideQuestionSection ? "d-none" : ""}
                                                      >
                                                        <div className="question-open-icon d-none">
                                                          <i className="pi pi-minus"></i>
                                                        </div>
                                                      </div>
                                                    ) : (
                                                      <div
                                                        role="button"
                                                        onClick={() =>
                                                          setQuestionOpenAndClose(true)
                                                        }
                                                      >
                                                        <div className="question-clos-icon">
                                                          <i className="pi pi-plus"></i>
                                                        </div>
                                                      </div>
                                                    )}
                                                    <div className={`questions-header ${hideQuestionSection ? "d-none" : "cursor-pointer-new"}`}>
                                                      {jobApplyLangLabels?.questions}
                                                      {!isCustomFormInvalid ? (
                                                        <span className="btn btn-primary completion-btn-primary completion-tag">{t("Complete")}</span>
                                                      ) : ""
                                                      }
                                                    </div>
                                                  </div>
                                                ) : (
                                                  ""
                                                )}
                                                <div className={`${qaShowHide}`}>
                                                  { jobDetails?.data?.data?.job?.questions?.length >
                                                    0 ? (
                                                    <div>
                                                      {jobDetails?.data?.data?.job?.questions?.filter((result: any) => result.section === null)?.map(
                                                        (ress: any) => {
                                                          return (
                                                            <div key={ress.extId}>
                                                              {ress.type === "open-ended" ? (
                                                                <>
                                                                  <div className="mb-3">
                                                                    <HTMLLabel
                                                                      className="form-label"
                                                                      label={ress.text}
                                                                      required={
                                                                        ress.required === 1
                                                                          ? true
                                                                          : false
                                                                      }
                                                                    />
                                                                    <Field
                                                                      onBlur={(e: any) =>
                                                                        e.preventDefault()
                                                                      }
                                                                      rows="4"
                                                                      as="textarea"
                                                                      name={ress.extId}
                                                                      className={"form-control"}
                                                                      validate={
                                                                        ress.required === 1
                                                                          ? fieldValidation
                                                                          : ""
                                                                      }
                                                                    />
                                                                    <ErrorMessage
                                                                      name={ress.extId}
                                                                      component={TextError}
                                                                    />
                                                                  </div>
                                                                </>
                                                              ) : (
                                                                ""
                                                              )}
                                                              {ress.type === "single" ? (
                                                                <>
                                                                  <div className="mb-3">
                                                                    <HTMLLabel
                                                                      className="form-label"
                                                                      label={ress.text}
                                                                      required={
                                                                        ress.required === 1
                                                                          ? true
                                                                          : false
                                                                      }
                                                                    />
                                                                    <div className="cust-checkbox-radio-inline">
                                                                      <Field
                                                                        name={ress.extId}
                                                                        validate={
                                                                          ress.required === 1
                                                                            ? fieldValidation
                                                                            : ""
                                                                        }
                                                                      >
                                                                        {({ field }: any) => {
                                                                          return ress.answers.map(
                                                                            (ress: any) => {
                                                                              // console.log("test",ress);
                                                                              return (
                                                                                  <div
                                                                                    key={ress.id}
                                                                                    className="form-check form-check-inline"
                                                                                  >
                                                                                    <input
                                                                                      className="form-check-input form-check-radio"
                                                                                      type="radio"
                                                                                      id={ress.id}
                                                                                      {...field}
                                                                                      value={
                                                                                        ress.id
                                                                                      }
                                                                                    />
                                                                                    <label
                                                                                      className="form-check-label"
                                                                                      htmlFor={
                                                                                        ress.id
                                                                                      }
                                                                                    >
                                                                                      {ress.text}
                                                                                    </label>
                                                                                  </div>
                                                                              );
                                                                            }
                                                                          );
                                                                        }}
                                                                      </Field>
                                                                    </div>
                  
                                                                    <ErrorMessage
                                                                      name={ress.extId}
                                                                      component={TextError}
                                                                    />
                                                                  </div>
                                                                </>
                                                              ) : (
                                                                ""
                                                              )}
                  
                                                              {ress.type === "multiple" ? (
                                                                <>
                                                                  <div className="mb-3">
                                                                    <HTMLLabel
                                                                      className="form-label"
                                                                      label={ress.text}
                                                                      required={
                                                                        ress.required === 1
                                                                          ? true
                                                                          : false
                                                                      }
                                                                    />
                                                                    <div className="cust-checkbox-radio-inline">
                                                                      <Field
                                                                        name={ress.extId}
                                                                        onBlur={(e: any) =>
                                                                          e.preventDefault()
                                                                        }
                                                                        validate={
                                                                          ress.required === 1
                                                                            ? fieldValidation
                                                                            : ""
                                                                        }
                                                                      >
                                                                        {({ field }: any) => {
                                                                          return ress.answers.map(
                                                                            (ress: any) => {
                                                                              return (
                                                                                  <div
                                                                                    key={ress.id}
                                                                                    className="form-check form-check-inline"
                                                                                  >
                                                                                    <input
                                                                                      className="form-check-input"
                                                                                      type="checkbox"
                                                                                      id={ress.id}
                                                                                      {...field}
                                                                                      value={
                                                                                        ress.id
                                                                                      }
                                                                                      checked={field?.value?.includes(
                                                                                        ress.id
                                                                                      )}
                                                                                    />
                                                                                    <label
                                                                                      className="form-check-label"
                                                                                      htmlFor={
                                                                                        ress.id
                                                                                      }
                                                                                    >
                                                                                      {ress.text}
                                                                                    </label>
                                                                                  </div>
                                                                              );
                                                                            }
                                                                          );
                                                                        }}
                                                                      </Field>
                                                                    </div>
                                                                    <ErrorMessage
                                                                      name={ress.extId}
                                                                      component={TextError}
                                                                    />
                                                                  </div>
                                                                </>
                                                              ) : (
                                                                ""
                                                              )}
                                                            </div>
                                                          );
                                                        }
                                                      )}
                                                    </div>
                                                  ) : (
                                                    ""
                                                  )}
                  
                  
                                                    { invalidQuestionSections?.[0]?.length >
                                                    0 ? (
                                                    <div>
                                                      {invalidQuestionSections?.[0]?.map(
                                                        (ress: any) => {
                                                          return (
                                                            <div key={ress.extId}>
                                                              {ress.type === "open-ended" ? (
                                                                <>
                                                                  <div className="mb-3">
                                                                    <HTMLLabel
                                                                      className="form-label"
                                                                      label={ress.text}
                                                                      required={
                                                                        ress.required === 1
                                                                          ? true
                                                                          : false
                                                                      }
                                                                    />
                                                                    <Field
                                                                      onBlur={(e: any) =>
                                                                        e.preventDefault()
                                                                      }
                                                                      rows="4"
                                                                      as="textarea"
                                                                      name={ress.extId}
                                                                      className={"form-control"}
                                                                      validate={
                                                                        ress.required === 1
                                                                          ? fieldValidation
                                                                          : ""
                                                                      }
                                                                    />
                                                                    <ErrorMessage
                                                                      name={ress.extId}
                                                                      component={TextError}
                                                                    />
                                                                  </div>
                                                                </>
                                                              ) : (
                                                                ""
                                                              )}
                                                              {ress.type === "single" ? (
                                                                <>
                                                                  <div className="mb-3">
                                                                    <HTMLLabel
                                                                      className="form-label"
                                                                      label={ress.text}
                                                                      required={
                                                                        ress.required === 1
                                                                          ? true
                                                                          : false
                                                                      }
                                                                    />
                                                                    <div className="cust-checkbox-radio-inline">
                                                                      <Field
                                                                        name={ress.extId}
                                                                        validate={
                                                                          ress.required === 1
                                                                            ? fieldValidation
                                                                            : ""
                                                                        }
                                                                      >
                                                                        {({ field }: any) => {
                                                                          return ress.answers.map(
                                                                            (ress: any) => {
                                                                              // console.log("test",ress);
                                                                              return (
                                                                                <>
                                                                                  <div
                                                                                    key={ress.id}
                                                                                    className="form-check form-check-inline"
                                                                                  >
                                                                                    <input
                                                                                      className="form-check-input form-check-radio"
                                                                                      type="radio"
                                                                                      id={ress.id}
                                                                                      {...field}
                                                                                      value={
                                                                                        ress.id
                                                                                      }
                                                                                    />
                                                                                    <label
                                                                                      className="form-check-label"
                                                                                      htmlFor={
                                                                                        ress.id
                                                                                      }
                                                                                    >
                                                                                      {ress.text}
                                                                                    </label>
                                                                                  </div>
                                                                                </>
                                                                              );
                                                                            }
                                                                          );
                                                                        }}
                                                                      </Field>
                                                                    </div>
                  
                                                                    <ErrorMessage
                                                                      name={ress.extId}
                                                                      component={TextError}
                                                                    />
                                                                  </div>
                                                                </>
                                                              ) : (
                                                                ""
                                                              )}
                  
                                                              {ress.type === "multiple" ? (
                                                                <>
                                                                  <div className="mb-3">
                                                                    <HTMLLabel
                                                                      className="form-label"
                                                                      label={ress.text}
                                                                      required={
                                                                        ress.required === 1
                                                                          ? true
                                                                          : false
                                                                      }
                                                                    />
                                                                    <div className="cust-checkbox-radio-inline">
                                                                      <Field
                                                                        name={ress.extId}
                                                                        onBlur={(e: any) =>
                                                                          e.preventDefault()
                                                                        }
                                                                        validate={
                                                                          ress.required === 1
                                                                            ? fieldValidation
                                                                            : ""
                                                                        }
                                                                      >
                                                                        {({ field }: any) => {
                                                                          return ress.answers.map(
                                                                            (ress: any) => {
                                                                              return (
                                                                                <>
                                                                                  <div
                                                                                    key={ress.id}
                                                                                    className="form-check form-check-inline"
                                                                                  >
                                                                                    <input
                                                                                      className="form-check-input"
                                                                                      type="checkbox"
                                                                                      id={ress.id}
                                                                                      {...field}
                                                                                      value={
                                                                                        ress.id
                                                                                      }
                                                                                      checked={field?.value?.includes(
                                                                                        ress.id
                                                                                      )}
                                                                                    />
                                                                                    <label
                                                                                      className="form-check-label"
                                                                                      htmlFor={
                                                                                        ress.id
                                                                                      }
                                                                                    >
                                                                                      {ress.text}
                                                                                    </label>
                                                                                  </div>
                                                                                </>
                                                                              );
                                                                            }
                                                                          );
                                                                        }}
                                                                      </Field>
                                                                    </div>
                                                                    <ErrorMessage
                                                                      name={ress.extId}
                                                                      component={TextError}
                                                                    />
                                                                  </div>
                                                                </>
                                                              ) : (
                                                                ""
                                                              )}
                                                            </div>
                                                          );
                                                        }
                                                      )}
                                                    </div>
                                                  ) : (
                                                    ""
                                                  )}
                                                </div>
                  
                                                <div className={`${qaShowHide}`}>
                                                  { Object.keys(profileQuestion)?.length > 0 ? (
                                                    <>
                                                      <div className="interests">{t("General")}</div>
                                                      <div className="row">
                                                        {Object.keys(profileQuestion).map(
                                                          (ress, i) => {
                                                            // console.log(ress);
                  
                                                            return (
                                                              <>
                                                                {profileQuestion[ress]["attributes"]
                                                                  ?.type === "singleselect" ? (
                                                                  <div key={i} className="mb-3">
                                                                    <HTMLLabel
                                                                      name={
                                                                        profileQuestion[ress]
                                                                          ?.fieldId
                                                                      }
                                                                      className="form-label"
                                                                      label={
                                                                        profileQuestion[ress]?.label
                                                                      }
                                                                      required={
                                                                        profileQuestion[ress]
                                                                          ?.attributes?.required
                                                                      }
                                                                    />
                                                                    <div className="cust-checkbox-radio-inline">
                                                                      {/* {profileQuestion[ress]?.fieldId} */}
                                                                      <Field
                                                                        name={
                                                                          profileQuestion[ress]
                                                                            ?.fieldId
                                                                        }
                                                                        validate={
                                                                          profileQuestion[ress]
                                                                            ?.attributes?.required
                                                                            ? fieldValidation
                                                                            : ""
                                                                        }
                                                                      >
                                                                        {({ field }: any) => {
                                                                          // console.log(field);
                                                                          return profileQuestion[
                                                                            ress
                                                                          ].option?.map(
                                                                            (subRess: any) => {
                                                                              // console.log("check", subRess);
                                                                              return (
                                                                                <>
                                                                                  <div
                                                                                    key={subRess.id}
                                                                                    className="form-check form-check-inline"
                                                                                  >
                                                                                    <input
                                                                                      className="form-check-input form-check-radio"
                                                                                      type="radio"
                                                                                      id={
                                                                                        subRess.id
                                                                                      }
                                                                                      {...field}
                                                                                      value={
                                                                                        subRess.id
                                                                                      }
                                                                                    />
                                                                                    <label
                                                                                      className="form-check-label"
                                                                                      htmlFor={
                                                                                        subRess.id
                                                                                      }
                                                                                    >
                                                                                      {
                                                                                        subRess.label
                                                                                      }
                                                                                    </label>
                                                                                  </div>
                                                                                </>
                                                                              );
                                                                            }
                                                                          );
                                                                        }}
                                                                      </Field>
                                                                    </div>
                                                                    <ErrorMessage
                                                                      name={
                                                                        profileQuestion[ress]
                                                                          ?.fieldId
                                                                      }
                                                                      component={TextError}
                                                                    />
                                                                  </div>
                                                                ) : (
                                                                  ""
                                                                )}
                                                                { (profileQuestion[ress]["attributes"]?.type === "multiselect" &&
                                                                    profileQuestion[ress]["attributes"]?.subtype === "depdropdown") ? (
                                                                  <>
                                                                    <div className="interests-section-parent">
                                                                      <div className="interests-section-left">
                                                                      <Label className="adres-form-heading"
                                                                        label="Interests"
                                                                        required={
                                                                          profileQuestion[ress]
                                                                            ?.attributes?.required
                                                                        }
                                                                      />
                                                                      <div className="form-group-inline">
                                                                        <Label
                                                                          name="Category"
                                                                          className="form-label"
                                                                          label={profileQuestion[ress]?.label  || "Category"}
                                                                        />
                                                                        <SingleSelect
                                                                          className="form-control-select form-control"
                                                                          placeholder="Please select an option"
                                                                          // value={tableControl.pageSize}
                                                                          onChange={(e: any) => {
                                                                            const { value } = e;
                                                                            formik.setFieldValue("interestprimarycategory", value?.toString());
                                                                            formik.setFieldValue("interestsubcategories", "");
                                                                            onSelectCategory(
                                                                              formik, 
                                                                              e.target,
                                                                              value, 
                                                                              profileQuestion[ress].option.filter((o: any) => o.value === value)
                                                                            );
                                                                          }}
                                                                          onInputChange={(e: any) => {
                                                                            getformStatus(formik);
                                                                          }}
                                                                          isSearchable={true}
                                                                          options={profileQuestion[ress].option}
                                                                          value={
                                                                            formik?.values["interestprimarycategory"]
                                                                              ? selectedCategoryDropdown?.depdropdown?.subcategory?.filter(
                                                                                (ress: any) =>
                                                                                  ress?.value ===
                                                                                  formik?.values["interestprimarycategory"]
                                                                              )[0]
                                                                              : ""
                                                                          }
                                                                        />
                                                                        {
                                                                          formik?.values["interestprimarycategory"] ? (
                                                                            <span 
                                                                              className="category-icon pi pi-times" 
                                                                              title="clear category selection"
                                                                              onClick={
                                                                                () => onClearPrimaryCategory(formik)
                                                                              }
                                                                            ></span>
                                                                          ) : ""
                                                                        }
                                                                        </div>
                                                                        <div className="form-group-inline">
                                                                          {/* <label className="form-label">{selectedCategoryDropdown?.depdropdown?.label || "Sub-Category"}</label> */}
                                                                          <Label
                                                                            name="Sub-Category"
                                                                            className="form-label"
                                                                            label={selectedCategoryDropdown?.depdropdown?.label || "Sub-Category"}
                                                                          />
                                                                          <SingleSelect
                                                                            className="form-control-select form-control"
                                                                            placeholder="Please select an option"
                                                                            onChange={(e: any) => {
                                                                              const { value, id } = e;
                                                                              formik.setFieldValue(
                                                                                "interestsubcategories",
                                                                                value?.toString()
                                                                              );
                                                                              onSelectSubCategory(formik, e.target, value, selectedCategoryDropdown?.depdropdown?.subcategory);
                                                                            }}
                                                                            onInputChange={(e: any) => {
                                                                              getformStatus(formik);
                                                                            }}
                                                                            isSearchable={true}
                                                                            value={
                                                                              formik?.values["interestsubcategories"]
                                                                                ? selectedCategoryDropdown?.depdropdown?.subcategory?.filter(
                                                                                  (ress: any) =>
                                                                                    ress?.value ===
                                                                                    formik?.values["interestsubcategories"]
                                                                                )[0]
                                                                                : ""
                                                                            }
                                                                            options={selectedCategoryDropdown?.depdropdown?.subcategory?.map((e:any) => ({
                                                                              label: e.value,
                                                                              value: e.attributes.id
                                                                            }))}
                                                                          />   
                                                                          {
                                                                            formik?.values["interestsubcategories"] ? (
                                                                              <span 
                                                                                className="category-icon pi pi-times" 
                                                                                title="clear category selection"
                                                                                onClick={
                                                                                  () => onClearSubCategory(formik)
                                                                                }
                                                                              ></span>  
                                                                            ) : ""
                                                                          }
                                                                      </div>
                                                                      <div className="d-flex justify-content-end">
                                                                        <button type="button" className="btn btn-primary completion-btn-primary"
                                                                          onClick={() =>
                                                                            addInterest(formik, profileQuestion[ress].option)
                                                                          }
                                                                        >Add Interest <i className="pi pi-arrow-right"></i></button>
                                                                      </div>
                                                                      {formik.status && formik.status.message && (
                                                                        <div className="error-message">{`${formik.status.message}`}</div>
                                                                      )}
                                                                      
                                                                      </div>
                                                                      <div className="interests-section-right">
                                                                        <h3 className="adres-form-heading">Selected Interests</h3>
                                                                        <div className="interests-section-right-box-parent"> 
                                                                        <Field type="textarea" name="categoryList" hidden="hidden"></Field>
                                                                        <FieldArray
                                                                          name="categoryList"
                                                                          render={(arrayHelpers:any) => { 
                                                                            return (
                                                                              <>
                                                                                {
                                                                                  addedCategoryReferenceList.map((pairItem:any, index:any) => {
                                                                                    return(
                                                                                      <>
                                                                                      {
                                                                                        pairItem?.categoryLabel ? (
                                                                                          <div key={index}>
                                                                                            <div className="interests-section-right-box">
                                                                                              <div className="interest-select-value">{`${pairItem?.categoryLabel} ${pairItem?.subcategoryLabel ? (" - " + pairItem?.subcategoryLabel) : ""}`}</div>   
                                                                                              <a className="delete-interest" onClick={() => removeCategoryPair(formik, pairItem)}>
                                                                                                <Image src={DeleteIcon} alt="delete" />
                                                                                              </a>
                                                                                            </div>
                                                                                          </div>
                                                                                        ) : ""
                                                                                      }
                                                                                      </>
                                                                                    );
                                                                                  })
                                                                                }
                                                                              </>
                                                                          );}
                                                                        }
                                                                        />                                                        
                                                                        </div>
                                                                      </div>                                                                                                        
                                                                    </div>     
                                                                    <div className="ps-3">
                                                                      <ErrorMessage name="categoryList" component={TextError}/>
                                                                    </div>                                                  
                                                                  </>
                                                                ) : (
                                                                  ""
                                                                )}
                                                                { (profileQuestion[ress]["attributes"]?.type === "multiselect" &&
                                                                    profileQuestion[ress]["attributes"]?.subtype !== "depdropdown") ? (
                                                                  <>
                                                                    <div className="mb-3">
                                                                      <HTMLLabel
                                                                        className="form-label"
                                                                        label={
                                                                          profileQuestion[ress]
                                                                            ?.label
                                                                        }
                                                                        required={
                                                                          profileQuestion[ress]
                                                                            ?.attributes?.required
                                                                        }
                                                                      />
                                                                      <div className="card p-2  job-multi-checkbox">
                                                                        <Field
                                                                          name={
                                                                            profileQuestion[ress]
                                                                              ?.fieldId
                                                                          }
                                                                          onBlur={(e: any) =>
                                                                            e.preventDefault()
                                                                          }
                                                                          validate={
                                                                            profileQuestion[ress]
                                                                              ?.attributes?.required
                                                                              ? fieldValidation
                                                                              : ""
                                                                          }
                                                                        >
                                                                          {({ field }: any) => {
                                                                            return profileQuestion[
                                                                              ress
                                                                            ].option?.map(
                                                                              (subRess: any) => {
                                                                                // console.log(subRess);
                  
                                                                                return (
                                                                                  <>
                                                                                    <div
                                                                                      key={
                                                                                        subRess.id
                                                                                      }
                                                                                      className="form-check form-check-inline"
                                                                                    >
                                                                                      <input
                                                                                        className="form-check-input"
                                                                                        type="checkbox"
                                                                                        id={
                                                                                          subRess.id
                                                                                        }
                                                                                        {...field}
                                                                                        value={
                                                                                          subRess.id
                                                                                        }
                                                                                        checked={field?.value?.includes(
                                                                                          subRess.id
                                                                                        )}
                                                                                      />
                                                                                      <label
                                                                                        className="form-check-label"
                                                                                        htmlFor={
                                                                                          subRess.id
                                                                                        }
                                                                                      >
                                                                                        {
                                                                                          subRess.label
                                                                                        }
                                                                                      </label>
                                                                                    </div>
                                                                                  </>
                                                                                );
                                                                              }
                                                                            );
                                                                          }}
                                                                        </Field>
                                                                      </div>
                                                                      <div className="pt-1">
                                                                        <ErrorMessage
                                                                          name={
                                                                            profileQuestion[ress]
                                                                              ?.fieldId
                                                                          }
                                                                          component={TextError}
                                                                        />
                                                                      </div>
                                                                    </div>
                                                                  </>
                                                                ) : (
                                                                  ""
                                                                )}
                                                              </>
                                                            );
                                                          }
                                                        )}
                                                      </div>
                                                    </>
                                                  ) : (
                                                    ""
                                                  )}
                                                </div>
                                              </div>
                  
                                              <div className="col-md-12"> 
                                                  {
                                                    extraQuestionSections.map((sectionData: any, index: number) => {
                                                      return (
                                                        <>
                                                          <div
                                                              className={`${jobPreViewSection ? "col-md-6" : "col-md-12"
                                                              }`}
                                                          >
                                                              {sectionData?.questionsField?.length > 0 ? (
                                                              <div className="questions-head d-flex d-sm-flex mt-4 pt-2  d-md-flex mb-sm-3 mb-3 mb-md-2">
                                                                  { getExtraSectionStatus(sectionData?.section_key) &&
                                                                  (sectionData
                                                                      ?.length > 0 ||
                                                                      Object.keys(sectionData).length >
                                                                      0) ? (
                                                                  <div
                                                                      role="button"
                                                                      
                                                                  >
                                                                      <div className="question-open-icon d-none">
                                                                      <i className="pi pi-minus"></i>
                                                                      </div>
                                                                  </div>
                                                                  ) : (
                                                                  <div
                                                                      role="button"
                                                                      
                                                                  >
                                                                      <div className="question-clos-icon">
                                                                      <i className="pi pi-plus"></i>
                                                                      </div>
                                                                  </div>
                                                                  )}
                                                                  <div className="questions-header">
                                                                  {t(sectionData?.title)}
                                                                  {!isCustomFormInvalid ? (
                                                                      <span className="d-none btn btn-primary completion-btn-primary completion-tag">{t("Complete")}</span>
                                                                  ) : ""
                                                                  }
                                                                  </div>
                                                              </div>
                                                              ) : (
                                                              ""
                                                              )}
                                                              
                                                              <div className={`${getExtraSectionStatus(sectionData?.section_key) ? "qashow" : "qahide" }`}>
                                                              { Object.keys(sectionData).length >
                                                                  0 ? (
                                                                  <div>
                                                                    <div className="extra_qus_content mb-2" dangerouslySetInnerHTML={{
                                                                    __html: sectionData.content
                                                                  }}></div>
                                                                  {sectionData?.questionsField?.map(
                                                                      (ress: any) => {
                                                                      return (
                                                                          <div key={ress.extId}>
                                                                          {ress.type === "open-ended" ? (
                                                                              <>
                                                                              <div className="mb-3">
                                                                                  <HTMLLabel
                                                                                  className="form-label"
                                                                                  label={ress.text}
                                                                                  required={
                                                                                      ress.required === 1
                                                                                      ? true
                                                                                      : false
                                                                                  }
                                                                                  />
                                                                                  <Field
                                                                                  onBlur={(e: any) =>
                                                                                      e.preventDefault()
                                                                                  }
                                                                                  rows="4"
                                                                                  as="textarea"
                                                                                  name={ress.extId}
                                                                                  className={"form-control"}
                                                                                  validate={
                                                                                      ress.required === 1
                                                                                      ? fieldValidation
                                                                                      : ""
                                                                                  }
                                                                                  />
                                                                                  <ErrorMessage
                                                                                  name={ress.extId}
                                                                                  component={TextError}
                                                                                  />
                                                                              </div>
                                                                              </>
                                                                          ) : (
                                                                              ""
                                                                          )}
                                                                          {ress.type === "single" ? (
                                                                              <>
                                                                              <div className="mb-3">
                                                                                  <HTMLLabel
                                                                                  className="form-label"
                                                                                  label={ress.text}
                                                                                  required={
                                                                                      ress.required === 1
                                                                                      ? true
                                                                                      : false
                                                                                  }
                                                                                  />
                                                                                  <div className="cust-checkbox-radio-inline">
                                                                                  <Field
                                                                                      name={ress.extId}
                                                                                      validate={
                                                                                      ress.required === 1
                                                                                          ? fieldValidation
                                                                                          : ""
                                                                                      }
                                                                                  >
                                                                                      {({ field }: any) => {
                                                                                      return ress.answers.map(
                                                                                          (ress: any) => {
                                                                                          // console.log("test",ress);
                                                                                          return (
                                                                                              <>
                                                                                              <div
                                                                                                  key={ress.id}
                                                                                                  className="form-check form-check-inline"
                                                                                              >
                                                                                                  <input
                                                                                                  className="form-check-input form-check-radio"
                                                                                                  type="radio"
                                                                                                  id={ress.id}
                                                                                                  {...field}
                                                                                                  value={
                                                                                                      ress.id
                                                                                                  }
                                                                                                  />
                                                                                                  <label
                                                                                                  className="form-check-label"
                                                                                                  htmlFor={
                                                                                                      ress.id
                                                                                                  }
                                                                                                  >
                                                                                                  {ress.text}
                                                                                                  </label>
                                                                                              </div>
                                                                                              </>
                                                                                          );
                                                                                          }
                                                                                      );
                                                                                      }}
                                                                                  </Field>
                                                                                  </div>
                  
                                                                                  <ErrorMessage
                                                                                  name={ress.extId}
                                                                                  component={TextError}
                                                                                  />
                                                                              </div>
                                                                              </>
                                                                          ) : (
                                                                              ""
                                                                          )}
                  
                                                                          {ress.type === "multiple" ? (
                                                                              <>
                                                                              <div className="mb-3">
                                                                                  <HTMLLabel
                                                                                  className="form-label"
                                                                                  label={ress.text}
                                                                                  required={
                                                                                      ress.required === 1
                                                                                      ? true
                                                                                      : false
                                                                                  }
                                                                                  />
                                                                                  <div className="cust-checkbox-radio-inline">
                                                                                  <Field
                                                                                      name={ress.extId}
                                                                                      onBlur={(e: any) =>
                                                                                      e.preventDefault()
                                                                                      }
                                                                                      validate={
                                                                                      ress.required === 1
                                                                                          ? fieldValidation
                                                                                          : ""
                                                                                      }
                                                                                  >
                                                                                      {({ field }: any) => {
                                                                                      return ress.answers.map(
                                                                                          (ress: any) => {
                                                                                          return (
                                                                                              <>
                                                                                              <div
                                                                                                  key={ress.id}
                                                                                                  className="form-check form-check-inline"
                                                                                              >
                                                                                                  <input
                                                                                                  className="form-check-input"
                                                                                                  type="checkbox"
                                                                                                  id={ress.id}
                                                                                                  {...field}
                                                                                                  value={
                                                                                                      ress.id
                                                                                                  }
                                                                                                  checked={field?.value?.includes(
                                                                                                      ress.id
                                                                                                  )}
                                                                                                  />
                                                                                                  <label
                                                                                                  className="form-check-label"
                                                                                                  htmlFor={
                                                                                                      ress.id
                                                                                                  }
                                                                                                  >
                                                                                                  {ress.text}
                                                                                                  </label>
                                                                                              </div>
                                                                                              </>
                                                                                          );
                                                                                          }
                                                                                      );
                                                                                      }}
                                                                                  </Field>
                                                                                  </div>
                                                                                  <ErrorMessage
                                                                                  name={ress.extId}
                                                                                  component={TextError}
                                                                                  />
                                                                              </div>
                                                                              </>
                                                                          ) : (
                                                                              ""
                                                                          )}
                                                                          </div>
                                                                      );
                                                                      }
                                                                  )}
                                                                  </div>
                                                              ) : (
                                                                  ""
                                                              )}
                                                              </div>
                  
                                                            
                                                          </div>
                                                        </>
                                                      );
                                                    })
                                                  }
                                              </div>  
                  
                                              { clientConfig?.data?.data?.clientSettings?.terms !== null ? (
                                              <div className={`mt-3 ${jobPreViewSection ? "col-6" : "col-12"
                                                  }`}>
                                                <div className="form-check form-check-inline form-check-terms">
                                                  <Field type="checkbox" name="tAndC" className="form-check-input"  id="tAndC" />                              
                                                  {parseTNC()}
                                                </div>
                                                <ErrorMessage name="tAndC" component={TextError} className="invalid-feedback" />                              
                                              </div>
                                              ) : "" }
                                            </div>
                                            {
                                              formik?.errors && <ErrorSummary errors={formik.errors}/>
                                            }                      
                                            <div
                                              className="text-end mb-3 d-xl-block d-none"
                                              ref={submitButtonRef}
                                            >
                                              <Button
                                                id="form-submit"
                                                type="submit"
                                                icon="pi pi-arrow-right"
                                                position=""
                                                label={
                                                  <div className="d-flex">
                                                    <div className="submit-job">
                                                      <i className="pi pi-check "></i>
                                                    </div>
                                                    <div className="">{jobApplyLangLabels?.submitApplication}</div>
                                                  </div>
                                                }
                                                clasName="btn btn-primary completion-btn-primary mt-3"
                                              />
                                            </div>
                                          </Form>
                                        )}
                                      </Formik>
                                    ) : (
                                      ""
                                    )}
                </div>
                
              </div>
              <div
                ref={sideBarWidth}
                className={`mt-4 ${jobPreViewSection ? "col-md-6 open-animet" : "d-none"
                  }`}
              >
                {/* style={{ minHeight: jobPreViewSection ? `${observedDiv?.current?.offsetHeight + submitButtonRef?.current?.offsetHeight + dynamikFormDataRef?.current?.offsetHeight + 68}px` : "0px" }} */}
                <div className="job-sidebar">
                  {/* <JobView /> */}
                  {/* pageHight={jobPreViewSection ? `${observedDiv?.current?.offsetHeight + submitButtonRef?.current?.offsetHeight + dynamikFormDataRef?.current?.offsetHeight + footerheight?.current?.offsetHeight}px` : "0px"}  */}
                  {/* // pageHight={(observedDiv?.current?.offsetHeight + submitButtonRef?.current?.offsetHeight + dynamikFormDataRef?.current?.offsetHeight + footerheight?.current?.offsetHeight) + 27} */}

                  <JobPreView
                    pageHight={careersTotalBody}
                  // pageHight={overAllSection?.current?.offsetHeight + residentialAddress?.current?.offsetHeight + documentationDiv?.current?.offsetHeight + footerheight?.current?.offsetHeight + 24}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="d-xl-none d-lg-block d-md-block d-sm-block d-block mobile-screen">
            { clientConfig?.data?.data?.clientSettings?.isMicroSite !== 1 ? (
            <Button
              onClick={() => setJobModel(true)}
              type="button"
              icon=""
              position=""
              label={
                <div className="d-flex justify-content-center align-items-center">
                  <div className="me-3">
                    <i className="pi pi-eye "></i>
                  </div>
                  <div className="preview">Preview Job Ad</div>
                </div>
              }
              clasName="btn  w-100 job-view-button mt-3"
            />
            ) : null }
            <Button
              onClick={() => document.getElementById("form-submit")?.click()}
              type="button"
              icon="pi pi-arrow-right"
              position=""
              label={
                <div className="d-flex justify-content-center">
                  <div className="submit-job">
                    <i className="pi pi-check "></i>
                  </div>
                  <div className="">Submit Application</div>
                </div>
              }
              clasName="btn btn-primary w-100 completion-btn-primary mt-3 mb-3"
            />
          </div>
          <Model
            className="modal-mobile-control"
            show={jobModel}
            size="lg"
            modelHeader={JobViewModelHeader()}
            modelBody={JobViewModel()}
          />
        </>
      ) : (
        <>
          {jobDetails?.data?.statusCode === 400 ? (
            <div className="card m-5">
              <div className="card-body text-center">
                {jobDetails?.data?.message}
              </div>
            </div>
          ) : (
            ""
          )}
        </>
      )}
    </>
  );
};

export default MicroJobApplay;
